export default class DefaultConfigurations {
  constructor() {}

  public setDefaultConfigs(): void {
    this._setupNonConfigs();
    this._setupDefaultConfigs();
  }

  private _setupNonConfigs(): void {
    console.log('+++setting up default non configs');
    CrowdHub_App.HTML_HEADER_LARGE = '';
    CrowdHub_App.HTML_FOOTER = '';

    CrowdHub_App.COMMENT_TYPE = {};
    CrowdHub_App.COMMENT_TYPE.CONTENT = 1;
    CrowdHub_App.COMMENT_TYPE.QUESTION = 2;

    CrowdHub_App.Resources = {};
    CrowdHub_App.Resources.ICON_COINS_MODAL = {
      src: 'xxxx.png',
      name: 'a',
    };
    CrowdHub_App.Resources.ICON_ACTION_MODAL = {
      src: 'img/Icon_Action_Modal.png',
      name: 'b',
    };
    CrowdHub_App.Resources.ICON_CLOSE_MODAL = {
      src: 'xxxx.png',
      name: 'c',
    };
    CrowdHub_App.Resources.ICON_ADDCOMMENT = { src: 'xxxx.png', name: 'd' };
    CrowdHub_App.Resources.ICON_LIKE = { src: 'xxxx.png', name: 'e' };
    CrowdHub_App.Resources.ICON_UNLIKE = { src: 'xxxx.png', name: 'e' };
    CrowdHub_App.Resources.ICON_LOGINWITHFACEBOOK = {
      src: 'xxxx.png',
      name: 'e',
    };

    CrowdHub_App.NOTIFICATION_ID_CONTENT = 2; // TODO need to deprecate
    CrowdHub_App.NOTIFICATION_ID_RESPONSE = 6; // TODO possible deprecated
    CrowdHub_App.NOTIFICATION_ID_UPDATECONTENT = 8; // TODO possible deprecated
    CrowdHub_App.NOTIFICATION_ID_USERLIST = 9; // TODO possible deprecated
    CrowdHub_App.NOTIFICATION_ID_CUSTOM = 12; // TODO possibly deprecated
    CrowdHub_App.NOTIFICATION_ID_REPLY = 14; // TODO possible deprecated

    CrowdHub_App.HTML_ENCODE = function (value) {
      //create a in-memory div, set it's inner text(which jQuery automatically encodes)
      //then grab the encoded contents back out.  The div never exists on the page.
      return $('<div/>').text(value).html();
    };

    CrowdHub_App.HTML_DECODE = function (value) {
      return $('<div/>').html(value).text();
    };

    Cordova_App.PASSIVE_SUPPORTED = false;

    window.HGEN = {};
    HGEN.span = HTMLGenerator_getSpan;
    HGEN.image = HTMLGenerator_getImage;
    HGEN.tree = HTMLGenerator_createTree;
    HGEN.textarea = HTMLGenerator_getTextArea;
    HGEN.input = HTMLGenerator_getInput;
    HGEN.combo = HTMLGenerator_getComboBox;
    HGEN.link = HTMLGenerator_getLink;
    HGEN.faicon = HTMLGenerator_getFAIcon;
    HGEN.label = HTMLGenerator_getLabel;
    HGEN.header = HTMLGenerator_getHeader;

    // list the breakpoints here

    CrowdHub_App.EXTERNAL_LINK = null;
    CrowdHub_App.PRELOAD_COMPLETE = false;
    CrowdHub_App.NOTIFICATION_COUNT_UNLIMITED = false;

    Cordova_App.ORIENTATION_CHANGE = 'orientationchange';
    Cordova_App.ORIENTATION_LANDSCAPE = 'LANDSCAPE';
    Cordova_App.ORIENTATION_PORTRAIT = 'PORTRAIT';
    Cordova_App.USER_DEVICE_TYPE = 'UNSET_TYPE';

    CrowdHub_App.SPEAKER_COUNTDOWN_TIMER = 'speakercntdwntimercounting';

    CrowdHub_App.EXTENDED_INPUT_TYPE_DECISION_LINKABLE = 'LINKABLE';
    CrowdHub_App.EXTENDED_INPUT_TYPE_DECISION_WYSIWYG = 'WYSIWYG';

    CrowdHub_App.LOGINMODE_CROWDHUB = 'crowdhub';
    CrowdHub_App.LOGINMODE_SAML = 'saml';
    CrowdHub_App.LOGINMODE_OAUTH = 'oauth';
    CrowdHub_App.LOGINMODE_TOKEN = 'token';
    CrowdHub_App.LOGINMODE_MAGIC_LINK = 'magic link';

    // this roles come into play when people are presenting their camera in sessions
    // if you are a moderator or publisher it means you had that preferred tag or were explicit allowed to publish in that session
    // if you are subscriber you are NOT allowed to publish in that session EXCEPT if you raise your hand!
    CrowdHub_App.STREAMROLE_MODERATOR = 'moderator';
    CrowdHub_App.STREAMROLE_PUBLISHER = 'publisher';
    CrowdHub_App.STREAMROLE_SUBSCRIBER = 'subscriber';

    CrowdHub_App.LASTROUTE = null;
  }

  private _setupConfigsForFET(): void {
    CrowdHub_App.CONFIG.CONTENT_EDITOR = {
      BUCKETS: {
        ENABLED_BUCKETS: [],
      },
    };

    // Partner
    CrowdHub_App.CONFIG.CONTENT_EDITOR.BUCKETS[CrowdHub_App.BUCKET_PARTNER] = {
      ACTIONS: [
        CrowdHub_App.ACTION_COMPLETE,
        CrowdHub_App.ACTION_FAVORITE,
        CrowdHub_App.ACTION_COMMENT,
        CrowdHub_App.ACTION_DOWNLOAD,
      ],
      TAGTYPES: [
        CrowdHub_App.TAGTYPE_ADMIN,
        CrowdHub_App.TAGTYPE_SESSION,
        CrowdHub_App.TAGTYPE_CATEGORY,
        CrowdHub_App.TAGTYPE_TITLE,
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_SWITCHPREFS,
        CrowdHub_App.TAGTYPE_LIVEEVENT,
      ],
      ANALYTICS_TAGTYPES: [CrowdHub_App.TAGTYPE_INTEREST, CrowdHub_App.TAGTYPE_ACCESSLEVEL],
    };

    // Speaker
    CrowdHub_App.CONFIG.CONTENT_EDITOR.BUCKETS[CrowdHub_App.BUCKET_SPEAKER] = {
      ACTIONS: [
        CrowdHub_App.ACTION_COMPLETE,
        CrowdHub_App.ACTION_FAVORITE,
        CrowdHub_App.ACTION_SHARE,
        CrowdHub_App.ACTION_COMMENT,
        CrowdHub_App.ACTION_DOWNLOAD,
      ],
      TAGTYPES: [
        CrowdHub_App.TAGTYPE_ADMIN,
        CrowdHub_App.TAGTYPE_SESSION,
        CrowdHub_App.TAGTYPE_CATEGORY,
        CrowdHub_App.TAGTYPE_TITLE,
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_SWITCHPREFS,
        CrowdHub_App.TAGTYPE_LIVEEVENT,
      ],
      ANALYTICS_TAGTYPES: [CrowdHub_App.TAGTYPE_INTEREST, CrowdHub_App.TAGTYPE_ACCESSLEVEL],
    };

    // OTSession
    CrowdHub_App.CONFIG.CONTENT_EDITOR.BUCKETS[CrowdHub_App.BUCKET_OTSESSION] = {
      ACTIONS: [
        CrowdHub_App.ACTION_START,
        CrowdHub_App.ACTION_FINISH,
        CrowdHub_App.ACTION_COMPLETE,
        CrowdHub_App.ACTION_FAVORITE,
        CrowdHub_App.ACTION_SHARE,
        CrowdHub_App.ACTION_COMMENT,
        CrowdHub_App.ACTION_DOWNLOAD,
      ],
      TAGTYPES: [
        CrowdHub_App.TAGTYPE_ADMIN,
        CrowdHub_App.TAGTYPE_SESSION,
        CrowdHub_App.TAGTYPE_CATEGORY,
        CrowdHub_App.TAGTYPE_TITLE,
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_SWITCHPREFS,
        CrowdHub_App.TAGTYPE_LIVEEVENT,
      ],
      ANALYTICS_TAGTYPES: [
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_ACCESSLEVEL,
        CrowdHub_App.TAGTYPE_ADMIN,
        CrowdHub_App.TAGTYPE_SESSION,
        CrowdHub_App.TAGTYPE_CATEGORY,
        CrowdHub_App.TAGTYPE_TITLE,
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_SWITCHPREFS,
        CrowdHub_App.TAGTYPE_LIVEEVENT,
      ],
    };

    // IRLSession
    CrowdHub_App.CONFIG.CONTENT_EDITOR.BUCKETS[CrowdHub_App.BUCKET_IRLSESSION] = {
      ACTIONS: [
        CrowdHub_App.ACTION_START,
        CrowdHub_App.ACTION_FINISH,
        CrowdHub_App.ACTION_COMPLETE,
        CrowdHub_App.ACTION_FAVORITE,
        CrowdHub_App.ACTION_SHARE,
        CrowdHub_App.ACTION_COMMENT,
        CrowdHub_App.ACTION_DOWNLOAD,
      ],
      TAGTYPES: [
        CrowdHub_App.TAGTYPE_ADMIN,
        CrowdHub_App.TAGTYPE_SESSION,
        CrowdHub_App.TAGTYPE_CATEGORY,
        CrowdHub_App.TAGTYPE_TITLE,
        CrowdHub_App.TAGTYPE_INTEREST,
        CrowdHub_App.TAGTYPE_SWITCHPREFS,
        CrowdHub_App.TAGTYPE_LIVEEVENT,
      ],
      ANALYTICS_TAGTYPES: [CrowdHub_App.TAGTYPE_INTEREST, CrowdHub_App.TAGTYPE_ACCESSLEVEL],
    };

    CrowdHub_App.CONFIG.SITE_EDITOR = {
      SETTINGS: {
        DEFAULT_ACTIONS: {
          OTSession: [CrowdHub_App.ACTION_COMPLETE, CrowdHub_App.ACTION_ATTEND],
          Partner: [CrowdHub_App.ACTION_COMPLETE],
          Speaker: [CrowdHub_App.ACTION_COMPLETE],
          Track: [CrowdHub_App.ACTION_COMPLETE, CrowdHub_App.ACTION_START, CrowdHub_App.ACTION_FINISH],
          Library: [CrowdHub_App.ACTION_COMPLETE],
        },
      },
      EDITSITE_ANALYTICS_DATE_THRESHOLD_MONTHS: null,
    };
  }

  private _setupDefaultConfigs(): void {
    console.log('+++setting up default configs');

    CrowdHub_App.CONFIG = {};
    CrowdHub_App.CONFIG.NAVIGATION = [];

    CrowdHub_App.CONFIG.SKIP_SAML_AUTH = true;

    CrowdHub_App.CONFIG.RESPECT_PUBNUB_CHECKTOKENS = true;

    CrowdHub_App.CONFIG.ALLOW_MULTIPLE_PUBNUBSESSIONS = true;
    CrowdHub_App.CONFIG.CONFIG_LOCATION = 'config_location';
    CrowdHub_App.CONFIG.APP_LANDING_URL = 'https://liveapp.junolive.co/';
    CrowdHub_App.CONFIG.LANDINGPAGE_SSO_INAPPBROWSER_PARAMS = 'location=yes';

    CrowdHub_App.CONFIG.USER_PRIVACY_TOGGLE = true;
    CrowdHub_App.CONFIG.ALLOWLOGIN = 'true';
    CrowdHub_App.CONFIG.ALLOWACCOUNTCREATION = 'true';
    CrowdHub_App.CONFIG.ALLOWACCOUNTDELETION = false;
    CrowdHub_App.CONFIG.ALLOWACCOUNTMESSAGEMOBILE = true;
    CrowdHub_App.CONFIG.ALLOW_PASSWORD_RESET = 'false';
    CrowdHub_App.CONFIG.FORGOTPASSWORD = 'true';
    CrowdHub_App.CONFIG.SUPPRESSCONTENTLOADING = 'false';
    CrowdHub_App.CONFIG.RSVP_WAITLIST = 'false';

    CrowdHub_App.CONFIG.ENCRYPTPASSWORD = 'true';
    CrowdHub_App.CONFIG.SALT = 'acjg2jgjc71273jcaje827';

    CrowdHub_App.CONFIG.EMAIL_PLACEHOLDER = 'Email';
    CrowdHub_App.CONFIG.FACEBOOKENABLED = 'true';

    if (App.CORDOVA == false) {
      CrowdHub_App.CONFIG.BASE_URL = window.location.protocol + '//' + window.location.hostname + '/';
      //CrowdHub_App.CONFIG.BASE_URL = 'https://liveapp.junolive.co/';

      // if(window.location.hostname.indexOf("localhost") < 0){
      //     CrowdHub_App.CONFIG.BASE_URL  = window.location.protocol + "//" + window.location.hostname + "/";
      // }else{
      //     CrowdHub_App.CONFIG.BASE_URL = `${window.location.protocol}//juno.localhost/`;
      // }
    } else {
      let configLoc = localStorage.getItem('config_location');
      console.log('+++config_location in setupDefaultConfigs: ' + configLoc);

      if (configLoc) {
        CrowdHub_App.CONFIG.BASE_URL = configLoc;
      } else if (window.JUNO_WHITELABEL_URL) {
        CrowdHub_App.CONFIG.BASE_URL = window.JUNO_WHITELABEL_URL;
      } else {
        CrowdHub_App.CONFIG.BASE_URL = CrowdHub_App.CONFIG.APP_LANDING_URL;
      }
    }

    console.log('+++CrowdHub_App.CONFIG.BASE_URL in setupDefaultConfigs:' + CrowdHub_App.CONFIG.BASE_URL);

    CrowdHub_App.CONFIG.AUTH_URL = 'https://auth.junolive.co/login/';
    CrowdHub_App.CONFIG.UNIVERSAL_FORWARD_URL = 'https://auth.junolive.co/forward/';

    CrowdHub_App.CONFIG.SHARE_URL = CrowdHub_App.CONFIG.BASE_URL + 'crowdhub_share_v2/'; //routing

    CrowdHub_App.CONFIG.MUST_LOGIN_REASON = null; //auth

    CrowdHub_App.CONFIG.FOOTER_SLUG = null;
    CrowdHub_App.CONFIG.FOOTER_HIDDEN_ROUTES = [];

    CrowdHub_App.CONFIG.HOURS_UNTIL_SHOWPROFILE = 48;
    CrowdHub_App.CONFIG.SKIP_PRELOAD = false;

    // SERVER LOCATIONS //////
    CrowdHub_App.CONFIG.API_PATH = CrowdHub_App.CONFIG.BASE_URL + 'crowdhub_api_v2/'; //routing
    CrowdHub_App.CONFIG.APP = 1;
    CrowdHub_App.CONFIG.ALLOW_LESSON_SKIP = false; // lessons
    CrowdHub_App.CONFIG.LOCK_COMPLETED_LESSONS = false; // lessons
    CrowdHub_App.CONFIG.ALLOW_THUMBS_DOWN = false; // communication
    CrowdHub_App.CONFIG.TITLE_HOME = 'Live'; //routing

    CrowdHub_App.CONFIG.BREAKPOINT_DESKTOPSMALL = 'desktop_small';
    CrowdHub_App.CONFIG.BREAKPOINT_TABLET = 'tablet';
    CrowdHub_App.CONFIG.BREAKPOINT_DESKTOP = 'desktop';
    CrowdHub_App.CONFIG.BREAKPOINT_PHONE = 'phone';
    CrowdHub_App.CONFIG.FORCE3D = true;
    CrowdHub_App.CONFIG.URL_ITEM = 'api_content_get.php';
    CrowdHub_App.CONFIG.URL_ITEM_SLUG = 'api_content_getBySlug.php';
    CrowdHub_App.CONFIG.SHARECONTENT = 'Share';

    CrowdHub_App.CONFIG.BUTTON_MEDIATYPE_FILE = 'Open File';
    CrowdHub_App.CONFIG.BUTTON_MEDIATYPE_TAKEPICTURE = 'Take Picture';
    CrowdHub_App.CONFIG.BUTTON_MEDIATYPE_TAKEVIDEO = 'Take Video';
    CrowdHub_App.CONFIG.BUTTON_MEDIATYPE_CHOOSEPICTURE = 'Choose Picture from Library';
    CrowdHub_App.CONFIG.BUTTON_MEDIATYPE_CHOOSEVIDEO = 'Choose Video from Library';
    CrowdHub_App.CONFIG.BUTTON_NOTIFICATIONS_CLEAR = 'Clear All';
    CrowdHub_App.CONFIG.BUTTON_EDITCOMMENT = 'Edit';
    CrowdHub_App.CONFIG.BUTTON_DELETECOMMENT = 'Delete';
    CrowdHub_App.CONFIG.BUTTON_REPORTCOMMENT = 'Report';

    CrowdHub_App.CONFIG.BREAKPOINT_TABLET_PX = 1024;
    CrowdHub_App.CONFIG.BREAKPOINT_PHONE_PX = 768;
    CrowdHub_App.CONFIG.BREAKPOINT_DESKTOPSMALL_PX = 1180;

    CrowdHub_App.CONFIG.PADDING_LARGE_MODELS =
      'iPhone10,6 iPhone10,3 iPhone11,8 iPhone11,2 iPhone11,6 SM-G973U iPhone11,2 iPhone11,4 iPhone11,6 iPhone11,8 iPhone12,1 iPhone12,3 iPhone12,5 iPhone12,8';

    CrowdHub_App.CONFIG.HIDE_UNWANTED_LIVE_ELEMENTS = []; //sessions

    CrowdHub_App.CONFIG.JWT_ALGORITHM = 'HS256'; // auth
    CrowdHub_App.CONFIG.JWT_SIGNINGKEY = 'f1fbc1ea48c2ef2482fb94a18dbb638e'; //auth

    CrowdHub_App.CONFIG.CALENDAR_INVITE_ALARM = false; //scheduling

    CrowdHub_App.CONFIG.CALENDAR_INVITE_TIME_BEFORE = '30M'; //scheduling

    CrowdHub_App.CONFIG.CALENDAR_EVENT_SHARE_OPTIONS = [
      {
        name: 'Apple',
        icon: 'ICON_APPLE',
        actionType: 'ICS',
      },
      {
        name: 'Google',
        icon: 'ICON_GOOGLE',
        actionType: 'GOOGLE_LINK',
      },
      {
        name: 'Office 365',
        icon: 'ICON_OFFICE_365',
        actionType: 'OFFICE_365_LINK',
      },
      {
        name: 'Outlook',
        icon: 'ICON_OUTLOOK',
        actionType: 'ICS',
      },
      {
        name: 'Outlook.com',
        icon: 'ICON_OUTLOOK_COM',
        actionType: 'OUTLOOK_COM_LINK',
      },
      {
        name: 'Yahoo',
        icon: 'ICON_YAHOO',
        actionType: 'YAHOO_LINK',
      },
    ]; //scheduling
    CrowdHub_App.CONFIG.ON_REGISTER_COMPLETE = null; //auth

    CrowdHub_App.CONFIG.TERMS_AND_PRIVACY_ON_LOGIN = false; //auth

    CrowdHub_App.CONFIG.SHOW_ADD_TO_CALENNDAR = false; //scheduling

    CrowdHub_App.CONFIG.FORCE_PROFILE_COMPLETION = true; //profile

    CrowdHub_App.CONFIG.ONBOARDING_DEFAULT_CHECKED_IDS = [];

    CrowdHub_App.CONFIG.STATUS_BAR_COLOR = null;

    //THIS IS THE AGREE TO TERMS STRING WITH LINKS
    // ! LANGS

    CrowdHub_App.CONFIG.APP_TERMSOFSERVICE = 'https://www.junolive.co/privacy-policy';
    CrowdHub_App.CONFIG.APP_PRIVACYPOLICY = 'https://www.junolive.co/privacy-policy';

    CrowdHub_App.CONFIG.AGREE_TO_TERMS = [
      {
        title: 'Privacy Policy',
        description: 'I have read and accept the terms defined in the ',
        url: 'https://www.junolive.co/privacy-policy',
      },
    ];

    CrowdHub_App.CONFIG.PARTNER_SESSIONS_PARAMS = {
      per_page: 6,
      sort: 4,
      enforce_end_date: 'true',
      buckets: 'OTSession',
    }; //sessions

    CrowdHub_App.CONFIG.API_KEY = '46646412'; //auth

    CrowdHub_App.CONFIG.RING_FOR_MILLISECONDS = 8000; //communication

    CrowdHub_App.CONFIG.ACCESS_LEVEL = {
      routing: {
        logout: false,
        type: 'external',
        path: 'https://www.google.com/',
      },
    }; // auth

    /** ACCESS LEVEL */
    CrowdHub_App.CONFIG.ALLOW_CONTENT_PREVIEW = true; //Booleans
    CrowdHub_App.CONFIG.ALLOW_SESSION_META_PREVIEW = true;
    CrowdHub_App.CONFIG.ALLOW_LESSON_QUESTION_PREVIEW = true; //Booleans
    CrowdHub_App.CONFIG.ALLOW_CALENDAR_ONLOGGEDOUT = false; //Booleans
    CrowdHub_App.CONFIG.ALLOW_IRL_ATTEND_PAST_SESSION = false; //Booleans
    CrowdHub_App.CONFIG.SHOW_LANDING_FOR_BASIC = false; //Booleans
    CrowdHub_App.CONFIG.SHOW_LANDING_FOR_SSO = true; //Booleans
    CrowdHub_App.CONFIG.HIDE_ATTENDEES_IN_PREVIEW = true; //Booleans

    CrowdHub_App.CONFIG.VIDEO_PREVIEW_BACKGROUND = 'rgba(0, 0, 0, 0.593)'; //Booleans
    CrowdHub_App.CONFIG.VIDEO_PREVIEW_COLOR = 'white'; //Booleans

    CrowdHub_App.CONFIG.HIDE_SESSION_TYPE = false; //sessions or even Booleans

    CrowdHub_App.CONFIG.HIDE_QUESTIONS_TIP = false; //communications or Booleans
    CrowdHub_App.CONFIG.MOBILE_HIDE_FOOTER = false;

    CrowdHub_App.CONFIG.SHOW_ATTEND_BUTTON_ON_LIST_VIEW = true; //scheduling

    //placeholder
    CrowdHub_App.CONFIG.PUBLISHING_DESKTOP_BG = null; //sessions
    CrowdHub_App.CONFIG.PUBLISHING_DESKTOP_ICON = null; //sessions

    CrowdHub_App.CONFIG.MODERATESTREAMMODAL_TIMEDEFAULT = 30; //sessions
    CrowdHub_App.CONFIG.MODERATESTREAMMODAL_CAPACITYDEFAULT = 20; //sessions
    CrowdHub_App.CONFIG.CREATEORUPDATEPROFILE_PASSWORDLENGTH = 8; //profile
    CrowdHub_App.CONFIG.CREATEORUPDATEPROFILE_CREATEBLURBSLUG = undefined; //profile
    CrowdHub_App.CONFIG.CREATEORUPDATEPROFILE_UPDATEBLURBSLUG = undefined; //profile

    // they at least let it load
    CrowdHub_App.CONFIG.CONSIDERED_STARTED = 0.01; //media
    // they watched half way through
    CrowdHub_App.CONFIG.CONSIDERED_WATCHEDHALF = 0.5; //media
    // when we consider that they have watched enough of the lesson to care
    CrowdHub_App.CONFIG.CONSIDERED_WATCHED = 0.6; //media
    // when we consider that they have watched everything!
    CrowdHub_App.CONFIG.CONSIDERED_WATCHEDFULLY = 0.8; //media

    CrowdHub_App.CONFIG.HLS_RETRY = 20; // sessions

    CrowdHub_App.CONFIG.ACCESSIBILITY = false; // TODO ?

    CrowdHub_App.CONFIG.JOINED_SESSION_ANNOUNCEMENT_DELAY = 5; // delays/timers

    CrowdHub_App.CONFIG.SHOW_USER_LASTNAME = false; // dimensions
    CrowdHub_App.CONFIG.SHOW_USER_LASTNAME_IN_MESSAGE = false; // communication
    CrowdHub_App.CONFIG.SHOW_USER_LASTNAME_IN_FORUM = true; // communication
    CrowdHub_App.CONFIG.SHOW_USER_DIMENSION_IN_MESSAGE_ID = -1; // communication
    CrowdHub_App.CONFIG.SHOW_USER_TAGTYPE_IN_MESSAGE_ID = -1; // communication
    CrowdHub_App.CONFIG.TAG_TYPE_FILTER_DISPLAY = 'type_name'; // tags?
    CrowdHub_App.CONFIG.STREAM_CONTAINER_SHOW_USER_LASTNAME = false; // sessions

    CrowdHub_App.CONFIG.SHOW_COMPANY = true; // dimensions

    CrowdHub_App.CONFIG.SHOW_SCHEDULE_NOTIFIER = true; // scheduling

    CrowdHub_App.CONFIG.REQUIRE_TEXT_IN_REVIEWS = false; // sessions

    CrowdHub_App.CONFIG.REQUIRE_GLOBAL_LOGIN = true; // auth
    CrowdHub_App.CONFIG.LOGGEDOUT_CAN_DOWNLOAD = false; // auth
    CrowdHub_App.CONFIG.NO_ACCESS_CAN_DOWNLOAD = false;
    CrowdHub_App.CONFIG.LOGGEDOUT_CAN_SEECOMMENT = false; // auth
    CrowdHub_App.CONFIG.LOGGEDOUT_CAN_SEEMETA = false; // auth
    CrowdHub_App.CONFIG.LOGGEDOUT_CAN_ENTERSESSIONN = false; // auth
    CrowdHub_App.CONFIG.USE_MAGIC_LINK_LOGIN = true;

    CrowdHub_App.CONFIG.LIVE_SESSION_APP_TEXT = 'Not at the event? '; //cordova
    CrowdHub_App.CONFIG.LIVE_SESSION_PAGE_LINK_TEXT = 'Watch the live stream'; //cordova

    CrowdHub_App.CONFIG.SHOWMODERATOR_STREAM_CONTROLS = true; // stop all, mute all // sessions
    CrowdHub_App.CONFIG.UNUSED_CONTROLS = ['stream_control_help', 'stream_control_whiteboard']; // the class of the icon to hide // sessions

    CrowdHub_App.CONFIG.ALLOW_CHAT_ON_SESSION_PREVIEW = false; // only works for irl sessions right now
    CrowdHub_App.CONFIG.REVIEW_AUTOSHOWONSESSION = false; //sessions
    CrowdHub_App.CONFIG.REVIEW_AUTOSHOWONBREAKOUT = false; // sessions
    CrowdHub_App.CONFIG.REVIEW_AUTOSHOWONPRIVATEMEETING = true; //sessions

    CrowdHub_App.CONFIG.PARTNER_CALLING = true; // communication
    CrowdHub_App.CONFIG.CHANNELS_ENABLED = true; // communication
    CrowdHub_App.CONFIG.PARTNER_ATTENDENCE_MODS_ONLY = true; // communication

    // made to get request
    CrowdHub_App.CONFIG.GOOGLEMAPS_GEOCODE_API =
      'https://maps.googleapis.com/maps/api/geocode/json?address=*%7CADDRESS%7C*&key=' + window.mapKey; // routing?
    // sometimes google has a hard time distinguishing countries etc, so this will force it to if you added this as "GOOGLEMAPS_GEOCODE_APPENDAGE":", New Zealand"
    CrowdHub_App.CONFIG.GOOGLEMAPS_GEOCODE_APPENDAGE = ''; // routing?

    CrowdHub_App.CONFIG.LANDING_ALLOW_ACCOUNTCREATION = true; // auth
    CrowdHub_App.CONFIG.LANDING_ALLOW_LOGIN = true; // auth
    CrowdHub_App.CONFIG.LANDING_LEARNMORE = true; // Booleans?
    CrowdHub_App.CONFIG.LEARN_MORE_URL = 'https://google.com/'; // ! lang

    CrowdHub_App.CONFIG.SPLASH_LOGO_URL = 'assets/ui/SplashLogo.svg'; // media
    CrowdHub_App.CONFIG.BACKGROUND_IMAGE_URL = 'assets/ui/SplashBackground.jpg'; //media
    CrowdHub_App.CONFIG.BACKGROUND_VIDEO_LINK = 'assets/ui/StandardBackground.mp4'; //media
    CrowdHub_App.CONFIG.BACKGROUND_AUTOPLAY = 'autoplay'; //! const
    CrowdHub_App.CONFIG.BACKGROUND_LOOP = 'loop'; //! const
    CrowdHub_App.CONFIG.BACKGROUND_MUTED = 'muted'; // !const

    CrowdHub_App.CONFIG.S3_URL = 'https://s3-us-west-2.amazonaws.com/crowdhublivecrowdhubapps/'; // routing
    CrowdHub_App.CONFIG.Avatars = [
      'Icon_UserAsianFemale.svg',
      'Icon_UserBlackElderly.svg',
      'Icon_UserBlackFemale.svg',
      'Icon_UserElderly.svg',
      'Icon_UserWhiteMale.svg',
      'Icon_UserBlackMale.svg',
    ]; // media

    this._setupConfigsForFET();

    CrowdHub_App.CONFIG.PRIVATE_MEETING_PARTNER_NAME = false; // scheduling or Booleans

    CrowdHub_App.CONFIG.DISPLAY_META_KEYS = [
      CrowdHub_App.META_INSTAGRAM,
      CrowdHub_App.META_FACEBOOK,
      CrowdHub_App.META_TWITTER,
      CrowdHub_App.META_LINKEDIN,
      CrowdHub_App.META_WEBSITE,
      CrowdHub_App.META_EMAIL,
      CrowdHub_App.META_PHONE,
      CrowdHub_App.META_LINK,
      CrowdHub_App.META_CONTACTUS,
    ]; // dimensions

    CrowdHub_App.CONFIG.ANALYTICSDATESELECTOR = [
      { value: 7, name: 'Last 7 Days' },
      { value: 30, name: 'Last 1 Month' },
      { value: 365, name: 'Last 12 Months' },
    ]; // dimensions
    CrowdHub_App.CONFIG.BRAND_AVAILABLE_COLOR = 'rgb(141, 215, 207)'; // colors
    CrowdHub_App.CONFIG.BRAND_BUSY_COLOR = 'rgb(242, 193, 157)'; // colors
    CrowdHub_App.CONFIG.BRAND_OTHER_BUSY_COLOR = 'rgb(251, 225, 146)'; //colors

    // !re-write as object, const
    CrowdHub_App.ROLE = {};
    CrowdHub_App.ROLE.NOOB = '0';
    CrowdHub_App.ROLE.USER = '2';
    CrowdHub_App.ROLE.ADMIN = '3';
    CrowdHub_App.ROLE.USER_DONOTDISTURB = '4';
    CrowdHub_App.ROLE.ADMIN_DONOTDISTURB = '5';

    CrowdHub_App.CONFIG.MIC_CHECK_URL = 'https://tokbox.com/developer/tools/precall/results'; // sessions

    CrowdHub_App.CONFIG.PARTNER_BOOK_TALK_COMPANYWIDE = false; // communication
    CrowdHub_App.CONFIG.SHOW_PARTNER_TALK_NOW_OPTIONS = true; // communication

    CrowdHub_App.CONFIG.TEST_ALL_CONNECTIONS = false; //routng or Booleans
    CrowdHub_App.CONFIG.TEST_SSO_CONNECTIONS = false; // auth or Booleans
    CrowdHub_App.CONFIG.TEST_LIVESESSION_CONNECTIONS = true; //sessions or Booleans
    CrowdHub_App.CONFIG.TEST_ACCOUNTCREATION_CONNECTIONS = true; // auth or Booleans

    CrowdHub_App.CONFIG.PUBLISHER_STATS_FREQ = 150; //logging
    CrowdHub_App.CONFIG.SUBSCRIBER_STATS_FREQ = 1500; //logging
    CrowdHub_App.CONFIG.NETWORK_STATS_FREQ = 1500; //logging

    CrowdHub_App.CONFIG.PACKETLOSS_ARRAY_LENGTH = 5; //sessions

    CrowdHub_App.CONFIG.PACKETLOSS_PERCENTAGE = 0.05; //sessions

    CrowdHub_App.CONFIG.LEADERBOARD_TAG_TYPE = null; // tags?

    CrowdHub_App.CONFIG.CHECK_STREAM_STATS = false; //logging
    CrowdHub_App.CONFIG.CHECK_PUBLISHER_STATS = false; // logging
    CrowdHub_App.CONFIG.CHECK_NETWORK_STATS = true; // logging

    CrowdHub_App.CONFIG.ALLOW_NOW_TIME_SCHEDULE = false; // scheduling

    // This number is multiplied by 24 to get milliseconds that the chat notification shows. 150 is roughly 3.5 seconds
    CrowdHub_App.CONFIG.TIME_TO_DISPLAY_CHAT_ACCEPT = 150; //communication

    CrowdHub_App.CONFIG.BROWSER_ERRORS = [
      {
        mobile: true,
        version: '14',
        platform: 'SAFARI',
        message:
          'There is a known issue on your version of Safari that may have a poor audio quality experience. Please update your device and join again if you have trouble.',
      },
      {
        mobile: false,
        version: '14.0.1',
        platform: 'SAFARI',
        message:
          'There is a known issue on your version of Safari that may have a poor audio quality experience. To avoid this problem please join using Chrome on desktop, or update to the newest version of iOS on iPad',
      },
      {
        mobile: false,
        version: '14.0.2',
        platform: 'SAFARI',
        message:
          'There is a known issue on your version of Safari that may have a poor audio quality experience. To avoid this problem please join using Chrome on desktop, or update to the newest version of iOS on iPad',
      },
      {
        mobile: false,
        version: '14',
        platform: 'SAFARI',
        message:
          'There is a known issue on your version of Safari that may have a poor audio quality experience. To avoid this problem please join using Chrome on desktop, or update to the newest version of iOS on iPad',
      },
    ]; // !const

    CrowdHub_App.CONFIG.HIDE_POINTS = false; // user points
    CrowdHub_App.CONFIG.HIDE_GROUP_POINTS = false; // group points
    CrowdHub_App.CONFIG.BASIC_PROFILE = false; // profile
    CrowdHub_App.CONFIG.LIMITED_PROFILE = false; // profile
    CrowdHub_App.CONFIG.HIDE_MOBILE_PROFILE_DROPDOWN_SETTINGS = true; // profile dropdown

    CrowdHub_App.CONFIG.HIDE_COUNTDOWN = false; // Booleans

    CrowdHub_App.CONFIG.ENABLED_MODERATOR_CHAT = true; // communication

    CrowdHub_App.CONFIG.RECORD_SESSION_PERCENTAGE_VIEWINGPERCENTAGE = true; // sessions

    CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_AS = 'navigate.landing'; // !const routing
    CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_AS = 'navigate.live.home'; // !const routing
    CrowdHub_App.CONFIG.ALLOW_LOGGEDOUT_ON_APP = false;

    CrowdHub_App.CONFIG.DEFAULT_LOGGEDOUT_URL = null; //routing
    CrowdHub_App.CONFIG.DEFAULT_LOGGEDIN_URL = null; //routing

    CrowdHub_App.CONFIG.BRAND_COLOR_TOASTR_INFO = 'var(--brand-color-white)'; //colors
    CrowdHub_App.CONFIG.BRAND_COLOR_TOASTR_INFO_BG = 'var(--brand-color)'; //colors
    CrowdHub_App.CONFIG.BRAND_COLOR_TOASTR_ERROR = 'var(--brand-color-white)'; //colors
    CrowdHub_App.CONFIG.BRAND_COLOR_TOASTR_ERROR_BG = 'var(--brand-color-error)'; //colors

    CrowdHub_App.CONFIG.PRESENCE_ONLINE_COLOR = '#1da237'; //colors
    CrowdHub_App.CONFIG.PRESENCE_OFFLINE_COLOR = '#d2d2d2'; //colors

    // chat pane colors
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_BG = 'var(--background-color-offblack)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_MESSAGES_BG = 'var(--background-color-offblack)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_MESSAGE_ENTRY_BG = '#000';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_MESSAGE_USER_NAME_COLOR = 'var(--text-color-grey);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_MESSAGE_NAME_COLOR = 'var(--text-color-light-grey);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_MESSAGE_COLOR = 'var(--text-color-white);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_LEFT_BORDER_COLOR = 'var(--brand-color-dark);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_SHOW_TOGGLE = 'var(--brand-color-white);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_SHOW_TOGGLE_BG = 'var(--brand-color);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_HIDE_TOGGLE = 'var(--brand-color-white);';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_HIDE_TOGGLE_BG = 'rgba(255, 255, 255, 0.1)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_TAB_BG = 'var(--background-color-offblack)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_TAB_COLOR = 'var(--text-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_TAB_SELECTED_BG = 'var(--brand-color)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_TAB_SELECTED_COLOR = 'var(--brand-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_INTERACTION_CONTAINER_TAB_DOT = 'var(--brand-color)';

    // STREAM VIEWING WINDOW COLORS
    CrowdHub_App.CONFIG.LIVE_SESSION_FIRST_USER_COLOR = 'var(--text-color-white);';
    CrowdHub_App.CONFIG.LIVE_SESSION_FIRST_USER_BG_COLOR = '#000';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_NAME_SIZE = 'var(--font-size-medium)';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_NAME_COLOR = 'var(--text-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_NAME_COLOR_HOVER = 'var(--brand-color)';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_MIC_COLOR = 'var(--brand-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_MIC_COLOR_SPEAKING = 'var(--brand-color)';
    CrowdHub_App.CONFIG.LIVE_SESSION_STREAM_MIC_SLASH_COLOR = 'var(--brand-color-bad)';
    CrowdHub_App.CONFIG.LIVE_SESSION_SIGNAL_BACK_COLOR = 'var(--brand-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_SIGNAL_FRONT_COLOR = 'var(--brand-color-good)';

    // Live Session Control Bar Colors
    CrowdHub_App.CONFIG.LIVE_SESSION_CONTROL_BAR_BG = '#000000';
    CrowdHub_App.CONFIG.LIVE_SESSION_CONTROL_BAR_ACTIVE_BG = 'var(--brand-color)';
    CrowdHub_App.CONFIG.LIVE_SESSION_CONTROL_BAR_TOOLTIP_COLOR = 'var(--brand-color-white)';
    CrowdHub_App.CONFIG.LIVE_SESSION_CONTROL_BAR_TOOLTIP_BG = 'var(--brand-color)';

    /** PREROLL */
    // config
    CrowdHub_App.CONFIG.PREROLL_VIDEO_TIME_OFFSET_THRESHOLD_MILLISECONDS = 2000; // sessions

    CrowdHub_App.CONFIG.HIDE_USER_INFO_ON_SCREENSHARE = true; //sessions

    CrowdHub_App.CONFIG.ANALYTICS_COLOR_OPTIONS = ['#2c88d9', '#1aae9f']; // colors
    CrowdHub_App.CONFIG.LIVE_ANALYTICS_SHOW_EXHIBITORS = true;
    CrowdHub_App.CONFIG.LIVE_ANALYTICS_SHOW_LIBRARY = true;

    // configurations for CME
    CrowdHub_App.CONFIG.CME_CONTENT_LESSON_CLAIM_BUTTON_LAYOUT = 'inline'; //!const ui
    CrowdHub_App.CONFIG.CME_CONTENT_TRACK_CLAIM_BUTTON_LAYOUT = 'block'; //!const ui
    CrowdHub_App.CONFIG.CME_CONTENT_TRACK_CLAIM_BUTTON_IS_BUTTON = false; //ui
    CrowdHub_App.CONFIG.CME_CONTENT_LESSON_CLAIM_BUTTON_IS_BUTTON = false; // ui
    CrowdHub_App.CONFIG.CME_ALLOW_USER_CLAIM_INCREMENT = 0.25; //!const ui
    ///END CME

    CrowdHub_App.CONFIG.PROGRESS_BAR_BG_COLOR = '#f4f4f4'; //colors
    CrowdHub_App.CONFIG.PROGRESS_BAR_STROKE_COLOR = '#c7169c'; //colors
    CrowdHub_App.CONFIG.PROGRESS_BAR_STROKE_WIDTH = 2.0; //!const ui

    CrowdHub_App.CONFIG.CME_CLIENT_REDIRECT = ''; //routing

    CrowdHub_App.CONFIG.LIVE_CHAT_ENABLED = false; //communication
    CrowdHub_App.CONFIG.LIVE_CHAT_URL = ''; //communication

    CrowdHub_App.CONFIG.NETWORK_STATUS_CHECK_NUM_RUN_TIMES = 3; //sessions
    CrowdHub_App.CONFIG.NETWORK_STATUS_CHECK_URL = CrowdHub_App.CONFIG.S3_URL + 'assets/ui/SplashBackground.jpg'; //media or sessions

    CrowdHub_App.CONFIG.KEEP_TAGS_INTACT_ON_UPDATE = [CrowdHub_App.TAGTYPE_ACCESSLEVEL]; // tags?

    CrowdHub_App.CONFIG.IOS_SUPPORT_BACKGROUND = ''; // media

    /**
     * App Colors
     * @example var(--brand-color) instead of #C7169C
     * */
    CrowdHub_App.CONFIG.PRIMARY_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.SECONDARY_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.ACCENT_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.TOPNAV_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.SUBNAV_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.SIDENAV_FONT_FAMILY = 'inherit';
    CrowdHub_App.CONFIG.BOTTOMNAV_FONT_FAMILY = 'inherit';

    CrowdHub_App.CONFIG.BRAND_FONT_FAMILY = "'Prompt',sans-serif";
    CrowdHub_App.CONFIG.BRAND_COLOR = '#C7169C';
    // in hex 1A = 10% opacity
    CrowdHub_App.CONFIG.BRAND_COLOR_10PERCENT = CrowdHub_App.CONFIG.BRAND_COLOR + '1A';
    CrowdHub_App.CONFIG.BRAND_COLOR_DARK = '#2D0523';
    CrowdHub_App.CONFIG.BRAND_COLOR_NAV = '#2D0523';
    CrowdHub_App.CONFIG.BRAND_COLOR_LIGHT = '#ea5fc9';
    CrowdHub_App.CONFIG.BRAND_COLOR_WHITE = '#ffffff';

    CrowdHub_App.CONFIG.BRAND_COLOR_GOOD = '#60be27';
    CrowdHub_App.CONFIG.BRAND_COLOR_BAD = '#f66d12';
    CrowdHub_App.CONFIG.BRAND_COLOR_ERROR = '#ff0202';
    CrowdHub_App.CONFIG.BRAND_COLOR_PROGRESS = '#c7169c';

    CrowdHub_App.CONFIG.PRERROLL_FILLMODE = 'fullscreen'; // !const sessions
    CrowdHub_App.CONFIG.VIDEOSTREAM_FILLMODE = 'fullscreen'; // !const sessions

    CrowdHub_App.CONFIG.STREAM_ICON_ON_COLOR = '#C7169C';
    CrowdHub_App.CONFIG.STREAM_ICON_ON_TEXT_COLOR = '#C7169C';
    CrowdHub_App.CONFIG.STREAM_ICON_OFF_COLOR = '#ffffff';
    CrowdHub_App.CONFIG.STREAM_ICON_OFF_TEXT_COLOR = '#ffffff';

    CrowdHub_App.CONFIG.SHOW_STREAM_CONTROL_HINTS = false; // ui or Booleans

    CrowdHub_App.CONFIG.USER_SPEAKING_BORDER = '#1cf32882'; // colors

    CrowdHub_App.CONFIG.DISABLE_SAML_NAMECHANGING = false; // profile

    CrowdHub_App.CONFIG.FLUSH_ANALYTICS_QUEUE = 10; // !const

    CrowdHub_App.CONFIG.BRAND_EXHIBITORSTRIP_COLOR = '#2e2e2e'; //colors

    CrowdHub_App.CONFIG.ONLINE_TIMES = [
      { value: 60 * 60 * 5, name: '5:00 a.m.' },
      { value: 60 * 60 * 6, name: '6:00 a.m.' },
      { value: 60 * 60 * 7, name: '7:00 a.m.' },
      { value: 60 * 60 * 8, name: '8:00 a.m.' },
      { value: 60 * 60 * 9, name: '9:00 a.m.' },
      { value: 60 * 60 * 10, name: '10:00 a.m.' },
      { value: 60 * 60 * 11, name: '11:00 a.m.' },
      { value: 60 * 60 * 12, name: '12:00 p.m.' },
      { value: 60 * 60 * 13, name: '1:00 p.m.' },
      { value: 60 * 60 * 14, name: '2:00 p.m.' },
      { value: 60 * 60 * 15, name: '3:00 p.m.' },
      { value: 60 * 60 * 16, name: '4:00 p.m.' },
      { value: 60 * 60 * 17, name: '5:00 p.m.' },
      { value: 60 * 60 * 18, name: '6:00 p.m.' },
      { value: 60 * 60 * 19, name: '7:00 p.m.' },
      { value: 60 * 60 * 20, name: '8:00 p.m.' },
      { value: 60 * 60 * 21, name: '9:00 p.m.' },
    ]; // !const or just move to db

    CrowdHub_App.CONFIG.OFFLINE_TIMES = [
      { value: 60 * 60 * 5, name: '5:00 a.m.' },
      { value: 60 * 60 * 6, name: '6:00 a.m.' },
      { value: 60 * 60 * 7, name: '7:00 a.m.' },
      { value: 60 * 60 * 8, name: '8:00 a.m.' },
      { value: 60 * 60 * 9, name: '9:00 a.m.' },
      { value: 60 * 60 * 10, name: '10:00 a.m.' },
      { value: 60 * 60 * 11, name: '11:00 a.m.' },
      { value: 60 * 60 * 12, name: '12:00 p.m.' },
      { value: 60 * 60 * 13, name: '1:00 p.m.' },
      { value: 60 * 60 * 14, name: '2:00 p.m.' },
      { value: 60 * 60 * 15, name: '3:00 p.m.' },
      { value: 60 * 60 * 16, name: '4:00 p.m.' },
      { value: 60 * 60 * 17, name: '5:00 p.m.' },
      { value: 60 * 60 * 18, name: '6:00 p.m.' },
      { value: 60 * 60 * 19, name: '7:00 p.m.' },
      { value: 60 * 60 * 20, name: '8:00 p.m.' },
      { value: 60 * 60 * 21, name: '9:00 p.m.' },
    ]; // !const or just move to db

    /**
     * Font Colors
     * @example var(--text-color-black) instead of #000000
     * @example var(--text-color-white) instead of white
     * */
    CrowdHub_App.CONFIG.TEXT_COLOR_BLACK = '#000000';
    CrowdHub_App.CONFIG.TEXT_COLOR_LIGHT_BLACK = '#05092e';
    CrowdHub_App.CONFIG.TEXT_COLOR_DARKER = '#333333';
    CrowdHub_App.CONFIG.TEXT_COLOR_DARKER_GREY = '#484848';
    CrowdHub_App.CONFIG.TEXT_COLOR_GREY = '#595959';
    CrowdHub_App.CONFIG.TEXT_COLOR_LIGHT_GREY = '#999999';
    CrowdHub_App.CONFIG.TEXT_COLOR_LIGHTER_GREY = '#DADADA';
    CrowdHub_App.CONFIG.TEXT_COLOR_WHITE = '#ffffff';
    //background colors
    CrowdHub_App.CONFIG.BACKGROUND_COLOR_LIGHT = '#ffffff';
    CrowdHub_App.CONFIG.BACKGROUND_COLOR_GREY = '#f2f2f2';
    CrowdHub_App.CONFIG.BACKGROUND_COLOR_OFF_BLACK = '#202020';
    CrowdHub_App.CONFIG.BACKGROUND_COLOR_DARK = '#000000';
    CrowdHub_App.CONFIG.BACKGROUND_COLOR_CHAT = '#6f7c88';
    //font sizes
    CrowdHub_App.CONFIG.TEXT_SIZE_X_SMALL = '8px';
    CrowdHub_App.CONFIG.TEXT_SIZE_SMALL = '12px';
    CrowdHub_App.CONFIG.TEXT_SIZE_MEDIUM = '14px';
    CrowdHub_App.CONFIG.TEXT_SIZE_LARGE = '16px';
    CrowdHub_App.CONFIG.TEXT_SIZE_LARGER = '18px';
    CrowdHub_App.CONFIG.TEXT_SIZE_X_LARGE = '20px';
    CrowdHub_App.CONFIG.TEXT_SIZE_XX_LARGE = '24px';
    CrowdHub_App.CONFIG.TEXT_SIZE_XXX_LARGE = '32px';
    CrowdHub_App.CONFIG.TEXT_SIZE_XXXX_LARGE = '64px';

    // JUNOSelect themes **To be updated when Jillian gets defaults back to me. For now, these will do.
    // Light theme
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_BG = '#fff';
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_BLACK;
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_NOTIFICATION = 'var(--brand-color)';
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_WHILECLICK_BG = CrowdHub_App.CONFIG.BACKGROUND_COLOR_GREY;
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_OPTIONS_BG = CrowdHub_App.CONFIG.BACKGROUND_COLOR_GREY;
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_OPTIONS_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_BLACK;
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_OPTIONS_HOVER_BG = '#cecece';
    CrowdHub_App.CONFIG.JUNOSELECT_LIGHT_OPTIONS_NOTIFICATION = 'var(--brand-color)';
    // Dark theme
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_BG = 'var(--brand-color)';
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_WHITE;
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_NOTIFICATION = CrowdHub_App.CONFIG.BACKGROUND_COLOR_LIGHT;
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_WHILECLICK_BG = CrowdHub_App.CONFIG.BACKGROUND_COLOR_OFF_BLACK;
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_OPTIONS_BG = CrowdHub_App.CONFIG.BACKGROUND_COLOR_DARK;
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_OPTIONS_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_WHITE;
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_OPTIONS_HOVER_BG = '#262626';
    CrowdHub_App.CONFIG.JUNOSELECT_DARK_OPTIONS_NOTIFICATION = 'var(--brand-color)';
    // Brand theme
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_BG = 'var(--brand-color)';
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_WHITE;
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_NOTIFICATION = CrowdHub_App.CONFIG.TEXT_COLOR_WHITE;
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_WHILECLICK_BG = CrowdHub_App.CONFIG.BRAND_COLOR_LIGHT;
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_OPTIONS_BG = CrowdHub_App.CONFIG.BACKGROUND_COLOR_GREY;
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_OPTIONS_COLOR = CrowdHub_App.CONFIG.TEXT_COLOR_BLACK;
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_OPTIONS_HOVER_BG = '#CECECE';
    CrowdHub_App.CONFIG.JUNOSELECT_BRAND_OPTIONS_NOTIFICATION = 'var(--brand-color)';

    //
    /**
     * FEATURED_ROTATOR_SLIDE header text alignment style configuration
     * options are: ui_textalign_center, ui_textalign_left, ui_textalign_right
     */
    CrowdHub_App.CONFIG.FEATURED_ROTATOR_SLIDE_TEXT_ALIGNMENT = '';

    CrowdHub_App.CONFIG.BACKGROUND_COLOR_LIVE_BUTTON = '#eedcd8';
    CrowdHub_App.CONFIG.COLOR_LIVE_BUTTON = '#ff0000';
    CrowdHub_App.CONFIG.IMG_LIVE_BUTTON = '/assets/ui/Icon_Red_Live.svg';

    CrowdHub_App.CONFIG.LIVE_CHAT_BUTTON_COLOR = '#ffffff';

    CrowdHub_App.CONFIG.BRAND_WHITE_MIX = 'rgba(255, 255, 255, .15)';
    CrowdHub_App.CONFIG.BRAND_DARK_MIX = 'rgba(0, 0, 0, .65)';

    CrowdHub_App.CONFIG.AWS_IVS_USE_AMBIENT_BACKGROUND = false; //media
    CrowdHub_App.CONFIG.AWS_IVS_SHOW_QUALITY_CONTROLS = false; //media
    CrowdHub_App.CONFIG.AWS_IVS_SHOW_AUDIO_VOLUME_SLIDER = false; //media
    CrowdHub_App.CONFIG.AWS_IVS_SHOW_SCRUB_BAR = false; //media
    CrowdHub_App.CONFIG.AWS_IVS_RECONNECT_TIMEOUT_IN_MS = 60000; // 300000 = 5 mins, minimum is 60000/1 minute // media

    CrowdHub_App.CONFIG.USES_BACKGROUND_VIDEO = true; // ui or Booleans
    CrowdHub_App.CONFIG.LET_MODERATORS_IN_SECONDS = 900; // sessions
    CrowdHub_App.CONFIG.USER_HEARTBEAT_TIME = 60000; // delays/timers
    CrowdHub_App.CONFIG.NOTIFICATION_REFRESHTIME = 60000 * 5; // delays/timers
    CrowdHub_App.CONFIG.PLACEANDPOINTS_REFRESHTIME = 300000; // only need this every 5 mins or so

    CrowdHub_App.CONFIG.MAX_CHAT_MESSAGES = 150; // communication

    CrowdHub_App.CONFIG.PANEL_CACHE_SECONDS = 300;

    CrowdHub_App.CONFIG.SCHEDULE_NOTIFIER_MAX = 600;
    CrowdHub_App.CONFIG.SCHEDULE_NOTIFIER_MIN = -300;

    CrowdHub_App.CONFIG.POPUP_NOTIFIER_MAX = 600;
    CrowdHub_App.CONFIG.POPUP_NOTIFIER_MIN = -300;

    CrowdHub_App.CONFIG.BROADCAST_TIMEOUT_BEFORE_LEAVE_IN_MILLISECONDS = 15000;

    CrowdHub_App.CONFIG.SNAP_PREROLL_TO_LIVE = true; // sessions
    CrowdHub_App.CONFIG.SNAP_PLAYERS_TO_LIVE = true; // sessions

    CrowdHub_App.CONFIG.HIDE_OUR_WISTIA_PLAY = true; // media

    CrowdHub_App.CONFIG.SHOW_LIBRARY_QUIZ_AS_OVERLAY = false; // ! not implemented yet

    CrowdHub_App.CONFIG.PERCENT_QUIZ_CORRECT_DEFAULT = 70;

    CrowdHub_App.CONFIG.DARK_MODE = false; // ui

    CrowdHub_App.CONFIG.LOGIN_MODE = 'crowdhub'; // auth
    CrowdHub_App.CONFIG.SSO_ERROR_URLS = {}; // !const auth
    CrowdHub_App.CONFIG.SSO_UPDATE_USER_URL = ''; // !const auth

    // config for setting up inputs
    CrowdHub_App.CONFIG.EXTENDED_INPUT_TYPE_DECISION = null; // ui
    CrowdHub_App.CONFIG.TEXTAREA_AUTO_SCROLL = false;

    CrowdHub_App.CONFIG.API_DOWNLOAD = 'custom_api/api_download_download.php'; // routing
    CrowdHub_App.CONFIG.HIDE_START_DATES = false; // scheduling
    CrowdHub_App.CONFIG.HIDE_LIVE_SESSION_TIMER = false; //sessions or ui or Booleans
    CrowdHub_App.CONFIG.HIDE_LIVE_SESSION_START_TIME = false; //sessions or ui or Booleans
    CrowdHub_App.CONFIG.MODERATORS_LIVESTREAM_COUNTDOWN_SHOW_TO_ALL = false; //sessions or ui or Booleans
    CrowdHub_App.CONFIG.MODERATOR_CAN_REQUEST_ATTENDEE_VIDEO = false; //sessions or Booleans

    CrowdHub_App.CONFIG.SNOOZE_TIME = '+ 2 Days'; // !lang
    CrowdHub_App.CONFIG.REMINDER_TIME = '+ 2 Days'; // !lang

    CrowdHub_App.CONFIG.ROTATOR_TITLE_DOTDOTDOT_HEIGHT = 50; // ui
    CrowdHub_App.CONFIG.HIDE_USER_JOIN_CHAT = false; // sessions or communication

    CrowdHub_App.CONFIG.SCHEDULE_BLOCK_SIZE = 900; // scheduling

    CrowdHub_App.CONFIG.CLIP_PREROLLS_AT_SECONDS = 2; // sessions
    CrowdHub_App.CONFIG.CLIP_PREROLLS_AT_SECONDS_MODERATORS = 10; //sessions

    CrowdHub_App.CONFIG.NUM_DAYS_BOOK_MEETING = 14; // scheduling

    CrowdHub_App.CONFIG.ENABLE_PRIVATE_MEETINGS = true; // communication

    CrowdHub_App.CONFIG.NO_ACTIVE_SPEAKER_OVERLAY_TEXT = 'No Active Speaker'; // !lang

    CrowdHub_App.CONFIG.ALLOWED_LOGGEDOUT_TYPES = [
      'sso',
      'oauthsso',
      'samlsso',
      'landing',
      'auth',
      'forgetPassword',
      'invitation',
      'tokenLogin',
    ]; //auth

    CrowdHub_App.CONFIG.JAVASCRIPT_TAGS = []; // TODO put somewhere important
    CrowdHub_App.CONFIG.CSS_RULES = []; // TODO put somewhere important

    // configs to not allow mobile landscape mode
    CrowdHub_App.CONFIG.NO_MOBILE_LANDSCAPE_OVERLAY_IS_ACTIVE = false; // ui
    CrowdHub_App.CONFIG.NO_MOBILE_LANDSCAPE_OVERLAY_HTML_TEMPLATE = null; // ui
    CrowdHub_App.CONFIG.NO_MOBILE_LANDSCAPE_OVERLAY_HTML_ICON_SOURCE = null; // ui

    // SSO CONFIGS
    CrowdHub_App.CONFIG.SSO_TOKENPARAMNAME = null;
    CrowdHub_App.CONFIG.SAML_ENABLED = false;
    CrowdHub_App.CONFIG.SAML_FORWARD_URL = '';
    CrowdHub_App.CONFIG.SAML_LOGOUT_URL = 'custom_api/saml/api_saml_logout.php';
    CrowdHub_App.CONFIG.SSO_SYNC_URL = 'custom_api/saml/api_saml_sync.php';
    CrowdHub_App.CONFIG.SSO_AUTH_URL = 'auth/auth_sso.php';

    CrowdHub_App.CONFIG.HIDE_ACCESSIBILITY = true;
    CrowdHub_App.CONFIG.HIDE_ACCESSIBILITY_FOCUS_OUTLINE = true;
    CrowdHub_App.CONFIG.SHOW_REQUIRED_ASTERISK = false;
    CrowdHub_App.CONFIG.SHOW_ROTATOR_PAUSE_BUTTON = false;

    CrowdHub_App.CONFIG.ARCHIVE_GREEN_ROOM = false; //sessions
    CrowdHub_App.CONFIG.PRIVATE_ROOMS_RECORDED = false; //sessions

    CrowdHub_App.CONFIG.PRIVATE_MEETING_INVITATION_MAXIMUM = 10; // communication or scheduling
    CrowdHub_App.CONFIG.ALLOW_PRIVATE_INVITES_BY_ALL = true; //communication

    CrowdHub_App.CONFIG.QAMESSAGE_SHOW_RESPONDER_NAME = true;
    CrowdHub_App.CONFIG.QAMESSAGE_SEND_ANSWER_TO_PRESENTER = true;
    CrowdHub_App.CONFIG.PUBNUB_UUID_PREFIX = '';
    CrowdHub_App.CONFIG.PUBNUB_PERSONALCHANNEL_PREFIX = 'pc';
    CrowdHub_App.CONFIG.PUBNUB_GROUPCHANNEL_PREFIX = 'gc';
    CrowdHub_App.CONFIG.PUBNUB_GLOBALROOM = 'demojuno3_global';
    CrowdHub_App.CONFIG.PUBNUB_PUBLISHKEY = 'pub-c-6b84209c-cfc7-4b08-bb9b-698500639d12';
    CrowdHub_App.CONFIG.PUBNUB_SUBSCRIBEKEY = 'sub-c-6e9cb740-495d-11eb-9ec5-221b84410db5';

    // Logging
    CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING = false;
    CrowdHub_App.CONFIG.VERBOSE_PUBLISHER_STATS_LOGGING = false;
    CrowdHub_App.CONFIG.VERBOSE_SUBSCRIBER_STATS_LOGGING = false;

    CrowdHub_App.CONFIG.USES_QUICKVIEW_PROFILE = false; // profile

    CrowdHub_App.CONFIG.HIDE_MODERATOR_BUTTON_AFTER_BREAKOUT = false; // sessions
    CrowdHub_App.CONFIG.PROFILE_PAGE_PASSWORD_AUTOCOMPLETE = 'new-password'; // profile
    CrowdHub_App.CONFIG.ENABLE_CLIENT_CME_API = false;

    CrowdHub_App.CONFIG.ENABLE_CME = true;
    CrowdHub_App.CONFIG.ENABLE_CE_CLAIM_BUTTON = false;
    CrowdHub_App.CONFIG.CE_CLAIM_HOST_DEFAULT = '';

    CrowdHub_App.CONFIG.FORCE_AVATAR_FINISHCREATE = false;

    if (window.MobileAccessibility) {
      window.MobileAccessibility.usePreferredTextZoom(false);
    }

    /** FONT AWESOME ICONS */
    CrowdHub_App.CONFIG.ICON_PREVIEW_VIDEO_LOCK = FontAwesomeConfigurations.ICON_LOCK_KEYHOLE;
    CrowdHub_App.CONFIG.ICON_USER_PLUS = FontAwesomeConfigurations.ICON_USER_PLUS;
    CrowdHub_App.CONFIG.ICON_ADD_MEDIA = FontAwesomeConfigurations.ICON_IMAGES;
    CrowdHub_App.CONFIG.ICON_TAG_CONTENT = FontAwesomeConfigurations.ICON_TAG;
    CrowdHub_App.CONFIG.ICON_TAG_USER = FontAwesomeConfigurations.ICON_CIRCLE_CHECK;

    CrowdHub_App.CONFIG.HIDDEN_REACTION_EMOJI_CATEGORIES = [
      'Activities',
      'Animals & Nature',
      // Custom,
      'Flags',
      'Food & Drink',
      'Objects',
      'People & Body',
      'Recently Used',
      'Smileys & People',
      'Symbols',
      'Travel & Places',
    ];

    CrowdHub_App.CONFIG.SCHEDULE_BUTTON_TOP_OF_BOOKTALK = false;

    // Threshold for number of sessions being downloaded in as a pdf from schedule panel
    // if num of attended sessions is higher than this number, the link will be sent via notification rather than opened automatically
    CrowdHub_App.CONFIG.SCHEDULE_PDF_EXPORT_NOTIFICATION_THRESHOLD = 1;

    CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT = false;
    CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_LIVE = false;
    CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_PAST = false;
    CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_UPCOMING = false;
    CrowdHub_App.CONFIG.ENABLE_PUBNUB_ATTENDEE_COUNT = true;
    CrowdHub_App.CONFIG.HIDE_DOWNLOADS_WHEN_DISABLED = false;

    CrowdHub_App.CONFIG.INVITATION_IDENTIFICATION = 'invitation_identification';

    CrowdHub_App.CONFIG.USING_PAGINATED_LAYOUT = true;
    CrowdHub_App.CONFIG.MAX_ATTENDEES_PAGE_SIZE = 16;

    CrowdHub_App.CONFIG.BUTTON_REPORTPOST = 'Report Post';
    CrowdHub_App.CONFIG.BUTTON_EDITPOST = 'Edit Post';

    // VNOW ANALYTICS PANEL CONFIGS
    CrowdHub_App.CONFIG.ANALYTICS_EXCLUDE_CATEGORIES = [];

    // CHAT PANE OPEN/CLOSED DEFAULTS
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_LIVESESSION_DESKTOP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_LIVESESSION_PHONE = false;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_LIVESESSION_APP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_IRLSESSION_DESKTOP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_IRLSESSION_PHONE = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_IRLSESSION_APP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_PARTNER_DESKTOP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_PARTNER_PHONE = false;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_PARTNER_APP = false;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_EPOSTER_DESKTOP = true;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_EPOSTER_PHONE = false;
    CrowdHub_App.CONFIG.CHAT_PANE_STARTS_OPEN_EPOSTER_APP = false;

    CrowdHub_App.CONFIG.STREAM_BLUR_SCREENSHARE_FOR_SHARER = true;

    CrowdHub_App.CONFIG.MAX_FILE_UPLOAD_SIZE_IN_BYTES = 10000000000; // 10GB

    CrowdHub_App.CONFIG.ALLOWED_DOC_FILE_TYPES = ['csv', 'doc', 'docx', 'pdf', 'xml']; // DON'T CHANGE THIS UNLESS TOLD
    CrowdHub_App.CONFIG.ALLOWED_IMAGE_FILE_TYPES = ['png', 'jpg', 'jpeg', 'gif']; // DON'T CHANGE THIS UNLESS TOLD
    CrowdHub_App.CONFIG.ALLOWED_VIDEO_FILE_TYPES = ['mp4', 'mov']; // DON'T CHANGE THIS UNLESS TOLD
    CrowdHub_App.CONFIG.ALLOWED_FILE_TYPES = [
      CrowdHub_App.CONFIG.ALLOWED_DOC_FILE_TYPES,
      CrowdHub_App.CONFIG.ALLOWED_IMAGE_FILE_TYPES,
      CrowdHub_App.CONFIG.ALLOWED_VIDEO_FILE_TYPES,
    ]; // DON'T CHANGE THIS UNLESS TOLD

    // config for stopping all publishers x seconds before live - default 30
    CrowdHub_App.CONFIG.GREENROOM_END_SECONDS = 30;
    // config for alerting publishers x seconds before GREENROOM_END_SECONDS - default 30
    CrowdHub_App.CONFIG.GREENROOM_END_ALERT_SECONDS = 30;
    CrowdHub_App.CONFIG.GREENROOM_END_ALERT_TYPE = 'warning'; // can be info, success, warning, error

    CrowdHub_App.CONFIG.WEB_PUSH_NOTIFICATION_DISPLAY_TIME = 5000; // 5 seconds
    CrowdHub_App.CONFIG.MUTE_WEB_PUSH_NOTIFICATION_DURING_MEETINGS = true;
    CrowdHub_App.CONFIG.ALLOW_NOTIFICATION_SNOOZING = false;
    CrowdHub_App.CONFIG.NOTIFICATION_SNOOZE_TIMES = [
      { snooze_time: 1800000, action_text: 'For 30 minutes' },
      { snooze_time: 3200000, action_text: 'For 1 hour' },
      { snooze_time: 6400000, action_text: 'For 2 hours' },
      {
        snooze_time: moment().add(1, 'days').startOf('day').toDate() - moment().toDate(),
        action_text: 'Until tomorrow',
      },
    ];

    this._setupDefaultLangs();
  }

  private _setupDefaultLangs(): void {
    console.log('+++setting up default langs');

    CrowdHub_App.LANG = {};

    CrowdHub_App.LANG.REPORT_COMMENT = 'Are you sure you want to report this comment?';
    CrowdHub_App.LANG.LABEL_NEWSLETTER = 'Yes! Please send me news about K-LOVE';

    CrowdHub_App.LANG.FORUMS_BREADCRUMB_HOME = 'Forum';
    CrowdHub_App.LANG.FORUMS_TOPIC_LABEL = 'Topic:';
    CrowdHub_App.LANG.FORUMS_LABEL = 'Forum';

    CrowdHub_App.LANG.PROFILE_DROPDOWN_INFO = 'My Information';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_CE = 'CME';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_BADGES = 'Achievements';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_LEADERBOARD = 'Leaderboard';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_HELPCHAT = 'Help Chat';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_CAM_VID_SETTINGS = 'Camera & Microphone';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATION_SETTINGS = 'Notification Preferences';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATIONS = 'Notifications';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_MESSAGES = 'Messages';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_ACCESSIBILITY = 'Accessibility';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_DECREASEFONTSIZE = 'Decrease font size';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_INCREASEFONTSIZE = 'Increase font size';
    CrowdHub_App.LANG.PROFILE_DROPDOWN_LOGOUT = 'Log out';
    CrowdHub_App.LANG.BREAKOUTS_PREPARING = 'Peparing Breakout Rooms';
    CrowdHub_App.LANG.BREAKOUTS_CREATING = 'Creating Breakout Rooms';

    CrowdHub_App.LANG.VIEW_GROUP_FEED = 'View Feed';
    CrowdHub_App.LANG.GROUP_POPULAR_POSTS_TITLE = 'Popular Posts';
    CrowdHub_App.LANG.COMMUNITY_SHARE_TITLE = 'Post';
    CrowdHub_App.LANG.COMMUNITY_SHARE_CANCEL = 'Cancel';
    CrowdHub_App.LANG.COMMUNITY_SHARE_ADD_TAGS = 'Add Tags';
    CrowdHub_App.LANG.ATTACH_MEDIA_TITLE = 'Attach Media';
    CrowdHub_App.LANG.TAG_MEMBERS_TITLE = 'Tag Members';

    CrowdHub_App.LANG.LOGIN_MAGIC_LINK_DESC =
      '<b>Use your magic link to sign in!</b><br>You can find this link in your welcome email.';
    CrowdHub_App.LANG.LOGIN_MAGIC_LINK_PASTE_DESC =
      '<b><em>Magic link not working?</em></b><br>Copy the magic link from your email and enter it below.';
    CrowdHub_App.LANG.LOGIN_MAGIC_LINK_PASTE_PLACEHOLDER = 'Paste magic link from email';
    CrowdHub_App.LANG.LOGIN_MAGIC_LINK_PASTE_BTN = 'Go';

    CrowdHub_App.LANG.BUTTON_DOWNLOADANDOPEN = 'Download to my phone';
    CrowdHub_App.LANG.BUTTON_OPENINBROWSER = 'Open in a browser';
    CrowdHub_App.LANG.DOWNLOAD_DESCRIPTION = 'Download *|FILENAME|*';

    CrowdHub_App.LANG.BUTTON_CONNECTROW_EDIT = 'Edit';
    CrowdHub_App.LANG.BUTTON_CONNECTROW_DELETE = 'Delete';
    CrowdHub_App.LANG.BUTTON_CONNECTROW_BLOCKUSER = 'Block Member';
    CrowdHub_App.LANG.BUTTON_CONNECTROW_REPORTUSER = 'Report Member';
    CrowdHub_App.LANG.BUTTON_CONNECTROW_REPORTPOST = 'Report Post';

    CrowdHub_App.LANG.ADD_SPEAKER_DESCRIPTION =
      'Would you like to save the representative defined with the role "Speaker" as the primary linked user for this Speaker page?';
    CrowdHub_App.LANG.ADD_SPEAKER_TITLE = 'Speaker Identified';
    CrowdHub_App.LANG.ADD_SPEAKER_SAVE_BUTTON = 'SAVE & LINK AS PRIMARY USER';
    CrowdHub_App.LANG.ADD_SPEAKER_SAVE_AS_REP_BUTTON = 'ONLY SAVE AS REPRESENTATIVE';

    CrowdHub_App.LANG.PAGETITLE_ACTION = 'Search Users';
    CrowdHub_App.LANG.PAGETITLE_TAGGEDUSERS = 'Tagged Users';
    CrowdHub_App.LANG.PAGETITLE_TAG = 'Tag Users';
    CrowdHub_App.LANG.PAGETITLE_DIRECTORY = 'Search Users';
    CrowdHub_App.LANG.PAGETITLE_MEMBERS = 'Search Members';

    CrowdHub_App.LANG.CALENDAR_INVITE_ALARM_MESSAGE = 'Your JUNO live event is starting soon!';
    CrowdHub_App.LANG.MESSAGE_BLOCKUSER = 'Are you sure you want to block this user?';
    CrowdHub_App.LANG.LABEL_COPIEDTOCLIPBOARD = 'Copied to clipboard!';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_TITLE = 'Send to Breakouts';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_TIMEDESCRIPTION = 'Breakout Duration (minutes)';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_CAPACITYDESCRIPTION = 'Room Capacity';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_BUTTONASSIGNRANDOMLY = 'Assign Randomly';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_BUTTONASSIGNBYTAGS = 'Prioritize by Tags';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_BUTTONASSIGNBYTAGSSUBMIT = 'Send It';
    CrowdHub_App.LANG.MODERATESTREAMMODAL_BUTTONCANCEL = 'Cancel';
    CrowdHub_App.LANG.BREAKOUT_ROUTE_CONFIRM = 'Ok';
    CrowdHub_App.LANG.BREAKOUT_ROUTE_TITLE = 'Breakout';
    CrowdHub_App.LANG.BREAKOUT_INFO_BAR_TITLE = 'Representatives are currently in breakouts';
    CrowdHub_App.LANG.BREAKOUT_INFO_BAR_VIEW_BTN = 'View Breakouts';
    CrowdHub_App.LANG.BREAKOUT_INFO_BAR_JOIN_BTN = 'Join a Breakout';
    CrowdHub_App.LANG.BREAKOUT_INFO_BAR_RETEIEVE_BTN = 'Retrieve';
    CrowdHub_App.LANG.BREAKOUT_SESSION_ENDED_TITLE = 'Session Ended';
    CrowdHub_App.LANG.LOGGEDOUT_BUTTON = 'Login';
    CrowdHub_App.LANG.BREAKOUTS_RETRIEVE_CONFIRMATION_TITLE = 'End Breakouts';
    CrowdHub_App.LANG.BREAKOUTS_RETRIEVE_CONFIRMATION_MESSAGE = 'Are you sure you want to end these breakouts early?';
    CrowdHub_App.LANG.BREAKOUTS_MONITOR_TITLE = '*|CONTENT_NAME|* Breakouts';
    CrowdHub_App.LANG.BREAKOUTS_MONITOR_MAIN_BTN = 'Return to *|CONTENT_NAME|*';
    CrowdHub_App.LANG.LOGIN_PANEL_EMAIL_TITLE = 'Email';
    CrowdHub_App.LANG.LOGIN_PANEL_PASSWORD_TITLE = 'Password';

    CrowdHub_App.LANG.SCHEDULE_MEETING_ENTER_MESSAGE_ERROR = 'Please enter a message!';
    CrowdHub_App.LANG.SCHEDULE_MEETING_ENTER_TIME_ERROR = 'Please select a time!';
    CrowdHub_App.LANG.SCHEDULED_MEETING_CHANGED_NOTIFICATION =
      'The start time of your Scheduled Meeting has been changed';

    CrowdHub_App.LANG.SCHEDULED_MEETING_CHANGED_NOTIFICATION_INVITED =
      "The start time of a Meeting you've been Invited to has been changed";

    CrowdHub_App.LANG.SELECT_AN_OPTION = 'Select an option';

    CrowdHub_App.LANG.TIMED_TRACK_WARNING =
      'This is a timed course, You will have *|TIME|* to complete it once you begin.';
    CrowdHub_App.LANG.TIMED_TRACK_REMAINING = 'Time remaining: *|TIME|*';

    CrowdHub_App.LANG.TIMED_OUT = 'Time Expired';

    CrowdHub_App.LANG.EXAM_START = 'Start';

    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_BUTTON = 'My Sessions';
    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_TOOLTIP = 'Requires attendance';
    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_POPUP_TITLE = "That's a big file!";
    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_POPUP_BODY = "We'll notify you when it's ready to download.";
    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_ERROR_TITLE = 'Uh oh!';
    CrowdHub_App.LANG.EXPORT_SESSIONS_TO_PDF_ERROR_BODY = 'There was an issue downloading your PDF.';

    CrowdHub_App.LANG.CHANGE_OR_CANCEL = 'Change or Cancel';
    CrowdHub_App.LANG.MEETING_CANCELED_APPEND = ' (Canceled)';

    // CANCEL A B2B MEETING
    CrowdHub_App.LANG.B2B_CANCEL_MEETING_CONFIRM = 'Yes';
    CrowdHub_App.LANG.B2B_CANCEL_MEETING_CANCEL = 'No';
    CrowdHub_App.LANG.B2B_CANCEL_MEETING_TITLE = 'Are you sure?';
    CrowdHub_App.LANG.B2B_CANCEL_MEETING_SUBTITLE =
      'Everyone associated will be unattended from the meeting and notified.';
    CrowdHub_App.LANG.B2B_CANCEL_MEETING_CANCELED = 'Canceled';

    CrowdHub_App.LANG.PREVIEW_SESSION_TITLE = 'Locked Content';
    CrowdHub_App.LANG.PREVIEW_SESSION_MESSAGE = 'Please log in to view.';
    CrowdHub_App.LANG.PREVIEW_SESSION_MESSAGE_LOGGEDIN = 'You must register to view this session.';
    CrowdHub_App.LANG.PREVIEW_SESSION_ACTION = 'Login Now';
    CrowdHub_App.LANG.PREVIEW_SESSION_ACTION_LOGGEDIN = 'Register Now';

    CrowdHub_App.LANG.PREVIEW_VIDEO_TITLE = 'Locked Content';
    CrowdHub_App.LANG.PREVIEW_VIDEO_MESSAGE = 'Please log in to preview.';
    CrowdHub_App.LANG.PREVIEW_VIDEO_PRIMARYACTION = 'Login to View';
    CrowdHub_App.LANG.PREVIEW_VIDEO_MUSTREGISTER = 'Register to View';

    CrowdHub_App.LANG.LOGINREASON_PREVIEWVIDEO = 'Login to view this video!';
    CrowdHub_App.LANG.LOGINREASON_TOPNAV = 'Login to access our full site!';
    CrowdHub_App.LANG.LOGINREASON_DOWNLOAD = 'Login to download this file!';
    CrowdHub_App.LANG.LOGINREASON_SCHEDULE = 'Please login to schedule meetings with other representatives!';
    CrowdHub_App.LANG.LOGINREASON_CHAT = 'Please login to chat with other representatives!';
    CrowdHub_App.LANG.LOGINREASON_SCHEDULEMEETING = 'Please login to schedule a meeting!';
    CrowdHub_App.LANG.LOGINREASON_MESSAGE = 'Please login to message other representatives!';
    CrowdHub_App.LANG.LOGINREASON_FOLLOW = 'Please login to follow other representatives!';
    CrowdHub_App.LANG.LOGINREASON_EXPIREDTOKEN =
      'Your login token has expired, please check your email for your new token!';
    CrowdHub_App.LANG.LOGINREASON_INVALIDTOKEN = 'Your login token is invalid, please request a new token!';
    CrowdHub_App.LANG.LOGINREASON_DEFAULT = 'You must login or create an account to do this!';
    CrowdHub_App.LANG.LOGINREASON_ATTEND = 'You must login or create an account to attend this session!';
    CrowdHub_App.LANG.LOGINREASON_JOINLIVE = 'You must login or create an account to join session.';
    CrowdHub_App.LANG.LOGINREASON_VIEWUSER = 'You must login or create an account to view other representatives.';
    CrowdHub_App.LANG.LOGINREASON_FAVORITE = 'Please login to like this page!';
    CrowdHub_App.LANG.LOGINREASON_CALL = 'Please login to call other representatives!';
    CrowdHub_App.LANG.LOGINEMAIL_PROMPT = 'Enter email address';
    CrowdHub_App.LANG.LOGIN_MAGIC_LINK_EMAIL_PROMPT = 'Enter email address';
    CrowdHub_App.LANG.LOGINPASSWORD_PROMPT = 'Enter password';
    CrowdHub_App.LANG.NEED_HELP = 'Need help?';
    CrowdHub_App.LANG.CONTACT_AT = 'Contact us at';
    CrowdHub_App.LANG.HELPDESK_EMAIL = 'support@junolive.co';

    CrowdHub_App.LANG.BUTTON_OTHER_USER_BUSY = 'CHOOSE ANOTHER';
    CrowdHub_App.LANG.BUTTON_CANCEL_CREATE_MEETING = 'CANCEL';
    CrowdHub_App.LANG.BUTTON_ATTEND_BOTH_MEETING = 'ATTEND BOTH';
    CrowdHub_App.LANG.BUTTON_BLACKOUT_ATTEND_ANYWAY_MEETING = 'ATTEND ANYWAY';
    CrowdHub_App.LANG.BUTTON_DECLINE_SPECIFIC_MEETING = 'DECLINE *|MEETINGNAME|*, Create this one';
    CrowdHub_App.LANG.CONFIRM_BLACKOUT_TEXT =
      'You have this time as a Blackout Range. Please choose from the following options:';
    CrowdHub_App.LANG.CONFIRM_BUSY_TEXT =
      'You are scheduled for *|MEETINGNAME|* during this time frame. Please choose from the following options:';
    CrowdHub_App.LANG.CONFIRM_OTHER_USER_BUSY_TEXT =
      'The chosen time block is not available. Please choose a different time block.';

    CrowdHub_App.LANG.BUTTON_SUBMITREVIEW = 'Submit Review';
    CrowdHub_App.LANG.BUTTON_NOTNOW = 'Not Now';

    CrowdHub_App.LANG.MODERATOR_YOUHAVEBEENKICKED = 'You have been kicked from this session, please be kind!';
    CrowdHub_App.LANG.MODERATOR_YOUHAVEBEENBANNED =
      'You have been banned from this platform, please contact support to have your account restored.';
    CrowdHub_App.LANG.MODERATOR_BUTTON_VIEWUSER = 'View User';

    CrowdHub_App.LANG.MODERATOR_BUTTON_DELETECHAT = 'Remove Message';
    CrowdHub_App.LANG.MODERATOR_BUTTON_KICKUSER = 'Kick User';
    CrowdHub_App.LANG.MODERATOR_QAOPTIONS_TITLE = 'Q&A Options';
    CrowdHub_App.LANG.MODERATOR_BUTTON_ASKPRESENTER = 'Ask the presenter';
    CrowdHub_App.LANG.MODERATOR_BUTTON_MARKASANSWERED = 'Mark as Answered';
    CrowdHub_App.LANG.MODERATOR_BUTTON_ADDANSWER = 'Add Answer';
    CrowdHub_App.LANG.MODERATOR_BUTTON_STOPPUBLISHING = 'Stop Publishing';
    CrowdHub_App.LANG.MODERATOR_BUTTON_KICKBANUSER = 'Kick + Ban User';
    CrowdHub_App.LANG.MODERATOR_BUTTON_MUTEAUDIO_YES = 'Mute Audio';
    CrowdHub_App.LANG.MODERATOR_DISABLED_AUDIO_TITLE = 'Audio Stopped';
    CrowdHub_App.LANG.MODERATOR_DISABLED_AUDIO_SUBTITLE = 'Your audio has been turned off by a moderator.';
    CrowdHub_App.LANG.MODERATOR_BUTTON_MUTEAUDIO_NO = 'Unmute Audio';
    CrowdHub_App.LANG.MODERATOR_ENABLED_AUDIO_TITLE = 'Enable Microphone';
    CrowdHub_App.LANG.MODERATOR_ENABLED_AUDIO_SUBTITLE = 'The moderator would like to turn on your microphone.';
    CrowdHub_App.LANG.MODERATOR_BUTTON_VIDEO_OFF = 'Disable Video';
    CrowdHub_App.LANG.MODERATOR_DISABLED_VIDEO_TITLE = 'Video Stopped';
    CrowdHub_App.LANG.MODERATOR_DISABLED_VIDEO_SUBTITLE = 'Your video has been turned off by a moderator.';
    CrowdHub_App.LANG.MODERATOR_BUTTON_VIDEO_ON = 'Enable Video';
    CrowdHub_App.LANG.MODERATOR_ENABLED_VIDEO_TITLE = 'Enable Video';
    CrowdHub_App.LANG.MODERATOR_ENABLED_VIDEO_SUBTITLE = 'The moderator would like to turn on your camera.';
    CrowdHub_App.LANG.MODERATOR_ENABLE_STREAM_CONFIRM = 'Allow';
    CrowdHub_App.LANG.MODERATOR_ENABLE_STREAM_DENY = 'Deny';
    CrowdHub_App.LANG.MODERATOR_REQUEST_NOTICE =
      'The person has been notified that they are being brought into the session. They will have the choice to share video and audio, audio only, or cancel the request.';
    CrowdHub_App.LANG.MODERATOR_REQUEST_CONFIRM_TITLE = 'You are being brought into the session';
    CrowdHub_App.LANG.MODERATOR_REQUEST_CONFIRM_SUBTITLE = 'Do you want to share video and audio or audio only?';

    CrowdHub_App.LANG.POLL_SELECT_A_QUESTION_TOOLTIP = 'Please select a question';
    CrowdHub_App.LANG.POLL_IS_ACTIVE_TOOLTIP = 'There is already an active poll';

    CrowdHub_App.LANG.USER_BUTTON_EXPAND_WINDOW = 'Expand Window';
    CrowdHub_App.LANG.USER_BUTTON_MINIMIZE_WINDOW = 'Minimize Window';
    CrowdHub_App.LANG.USER_BUTTON_VIEW_CONTACT = 'View Contact';

    CrowdHub_App.LANG.END_ENTIRE_SESSION_NOTICE_ALERT_TITLE_TEXT = 'The Session has ended.';
    CrowdHub_App.LANG.END_ENTIRE_SESSION_NOTICE_ALERT_MESSAGE = '*|NAME|* ended the session.';
    CrowdHub_App.LANG.END_ENTIRE_SESSION_CONFIRM_TITLE = 'Please Confirm!';
    CrowdHub_App.LANG.END_ENTIRE_SESSION_CONFIRM_TEXT =
      'Are you sure? This will disconnect ALL users from the session and you will not be able to restart it.';
    CrowdHub_App.LANG.END_ENTIRE_SESSION_CONFIRM_BUTTON_TEXT = 'OK, End Session';
    CrowdHub_App.LANG.END_ENTIRE_SESSION_CANCEL_BUTTON_TEXT = 'CANCEL';

    CrowdHub_App.LANG.TIMED_TRACK_TITLE = 'Timed Course';
    CrowdHub_App.LANG.TIMED_TRACK_DESCRIPTION =
      'You will only have *|TIME|* to complete this course once you start, do you wish to begin?';

    CrowdHub_App.LANG.TIMED_TRACK_TITLE_EXPIRED = 'Time Expired';
    CrowdHub_App.LANG.TIMED_TRACK_DESCRIPTION_EXPIRED = 'You have run out of time!';

    CrowdHub_App.LANG.TIMED_TRACK_BUTTON_BEGIN = 'Begin';
    CrowdHub_App.LANG.TIMED_TRACK_BUTTON_CANCEL = 'Cancel';
    CrowdHub_App.LANG.TIMED_TRACK_BUTTON_TIMEEXPIRED = 'Okay';

    CrowdHub_App.LANG.SESSION_ATTEND_TEXT = 'Attend';
    CrowdHub_App.LANG.SESSION_ATTENDING_TEXT = 'Attending';
    CrowdHub_App.LANG.MEMBERS_ATTENDING = '*|COUNT|* Attending';
    CrowdHub_App.LANG.ATTENDING = 'Attending';
    CrowdHub_App.LANG.IRL_SESSION_LIVE_TITLE = 'In-Person Session';
    CrowdHub_App.LANG.IRL_SESSION_LIVE_TEXT =
      'This session is happening in-person only and is not available via streaming. Interact live with others through the chat sidebar.';
    CrowdHub_App.LANG.IRL_SESSION_ENDED_TEXT = 'This In-Person Session has ended.';

    CrowdHub_App.LANG.BACK_TO_COURSESBUTTON = 'Back to Courses';
    CrowdHub_App.LANG.NEXT_COURSE = 'Next Course';
    CrowdHub_App.LANG.CONTINUE_COURSE_BUTTON = 'Continue Course';
    CrowdHub_App.LANG.FINISH_COURSE = 'Finish Course';
    CrowdHub_App.LANG.NEXT_LESSON = 'Next Lesson';

    CrowdHub_App.LANG.NEWMESSAGES = '↓ *|COUNT|* New Messages ↓';

    CrowdHub_App.LANG.LEADERBOARD_RESET_TEXT =
      'The leaderboard resets every month. Earn points by interacting with the *|ICON|* throughout the platform.';

    CrowdHub_App.LANG.PRODUCT_CTA_BUTTON = 'Visit Page';

    CrowdHub_App.LANG.EDIT_CONTENT_LEVEL = 'Level';
    CrowdHub_App.LANG.EDIT_CONTENT_INTERESTS = 'Interests';
    CrowdHub_App.LANG.ACCOUNT_MICTEST = 'Test your setup';
    CrowdHub_App.LANG.ACCUONNT_MICTEST_DESCRIPTION =
      "Test your mic and video by visiting our testing page. <span class='brand_color_color'>Click Here</span> (opens in a new window).";

    CrowdHub_App.LANG.ACCOUNT_MAGIC_LINK = 'Get Magic Link';
    CrowdHub_App.LANG.LOGIN_GET_MAGIC_LINK = 'GET MAGIC LINK';
    CrowdHub_App.LANG.ACCOUNT_MAGIC_LINK_DESC = 'Get your link to access the JUNO Live app';
    CrowdHub_App.LANG.ACCOUNT_MAGIC_LINK_DESCRIPTION =
      "Enter your email and we'll send you a magic link to automatically login without a password.";
    CrowdHub_App.LANG.ACCOUNT_LOGIN_EMAIL_PASSWORD = 'Login with email and password';
    CrowdHub_App.LANG.ON_MAGIC_LINK_SENT = `<b>Verifying Your Account</b><br>You should see a new magic link in your email if everything checks out!
                <br><br><span style='font-size:var(--font-size-x-small)'>If you're having issues receiving your magic link and have double-checked that the email you've provided is correct, 
                please reach out to <a href='mailto:support@email.com'>support@email.com</a> for help with your account.<span>`;

    CrowdHub_App.LANG['ERROR:99'] =
      `<strong>We're sorry, but it seems that your account is currently banned.</strong><br><br>If you think there's been a mistake, please contact <a href="mailto:` +
      CrowdHub_App.LANG.HELPDESK_EMAIL +
      `">` +
      CrowdHub_App.LANG.HELPDESK_EMAIL +
      `</a> for help getting your account up and running again.`;

    CrowdHub_App.LANG.EDIT_CONTENT_TAB_INFORMATION = 'Information';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_ROTATORS = 'Rotators';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_PARTNERS = 'Exhibitors';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_MEMBERS = 'Representatives';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_RESOURCES = 'Resources';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_QUESTIONS = 'Questions';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_SESSIONS = 'Sessions';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_ANALYTICS = 'Analytics';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_EXAMINE_YOUR_DATA = 'Examine Your Data';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_METADATA = 'Meta Data';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_STREAM = 'Stream';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_PRESENTERS = 'Presenters';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_SPEAKERS = 'Speakers';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_CONTENT = 'Content';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_SETTINGS = 'Settings';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_CERTIFICATE = 'Certificate';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_LESSONS = 'Lessons';
    CrowdHub_App.LANG.EDIT_SITE_TAB_MEMBERS = 'Members';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_THEME = 'Theme';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_PRODUCTS = 'Products';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_GREETINGS = 'Greetings';
    CrowdHub_App.LANG.EDIT_CONTENT_TAB_NOTIFICATIONS = 'Notifications';
    CrowdHub_App.LANG.EDIT_CONTENT_LEAVE_WITHOUT_SAVING = 'Leave without saving changes?';
    CrowdHub_App.LANG.ANALYTICS_ACTIVE_USERS_TITLE = 'ACTIVE USERS';
    CrowdHub_App.LANG.ANALYTICS_LIVE_SESSIONS_TITLE = 'LIVE SESSIONS';
    CrowdHub_App.LANG.ANALYTICS_SESSION_ATTENDANCE_TITLE = 'SESSION ATTENDANCE';
    CrowdHub_App.LANG.ANALYTICS_LIBRARY_VIEWS_TITLE = 'LIBRARY PAGES:<br>ACTIVE VIEWERS';
    CrowdHub_App.LANG.ANALYTICS_EXHIBITOR_VIEWS_TITLE = 'EXHIBITOR PAGES:<br>ACTIVE VIEWERS';

    CrowdHub_App.LANG.EDITSITE_ATTENDANCE_RATE = 'ATTENDANCE RATE';
    CrowdHub_App.LANG.EDITSITE_USER_SESSION_ENGAGEMENT = 'USER SESSION ENGAGEMENT';
    CrowdHub_App.LANG.EDITSITE_AVG_SESSION_VIEW_DURATION = 'AVG SESSION VIEW DURATION';
    CrowdHub_App.LANG.EDITSITE_AVG_BOOTH_VISITS = 'AVG BOOTH VISITS';
    CrowdHub_App.LANG.EDITSITE_NEW_USER_RATE = 'NEW USER RATE';

    CrowdHub_App.LANG.LIVE_CONTENT_TITLE = 'LIVE';

    CrowdHub_App.LANG.EDIT_CONTENT_IMAGES = 'Images';
    CrowdHub_App.LANG.EDIT_CONTENT_IMAGE = 'Image';
    CrowdHub_App.LANG.EDIT_CONTENT_ACTIONS = 'Actions';
    CrowdHub_App.LANG.EDIT_CONTENT_STATUS = 'Status';
    CrowdHub_App.LANG.EDIT_CONTENT_TAGS = 'Tags';
    CrowdHub_App.LANG.EDIT_CONTENT_VIEW_PAGE = 'View Page';
    CrowdHub_App.LANG.EDIT_CONTENT_ACTIVE = 'Active';
    CrowdHub_App.LANG.EDIT_CONTENT_ALLOW = 'Allow';
    CrowdHub_App.LANG.EDIT_CONTENT_NAME = 'Name';
    CrowdHub_App.LANG.EDIT_CONTENT_URL = 'Url';
    CrowdHub_App.LANG.EDIT_CONTENT_PREVIEW = 'Preview Text';
    CrowdHub_App.LANG.EDIT_LOCATION_PREVIEW = 'Location';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_ROTATORS_FOR = 'Current Rotators for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_SESSIONS_FOR = 'Current Sessions for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_META_DATA_FOR = 'Current Meta Data for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_MEMBERS_FOR = 'Current Representatives for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_LESSONS_FOR = 'Lesson Plan';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_SPEAKERS_FOR = 'Current Speakers for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_PARTNERS_FOR = 'Current Exhibitors for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_RESOURCES_FOR = 'Current Resources for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_QUESTIONS_FOR = 'Current Questions for';
    CrowdHub_App.LANG.EDIT_CONTENT_CURRENT_PRODUCTS_FOR = 'Current Products for';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_ROTATOR = 'Add Rotator';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_MEMBER = 'Add Member';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_PRESENTER = 'Add Presenter';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_SPEAKER = 'Add Speaker';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_PARTNER = 'Add Partner';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_LESSON = 'Add Lesson';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_PRODUCT = 'Add Product';
    CrowdHub_App.LANG.ADD_EDIT_ROTATOR = 'Add / Edit Rotator';
    CrowdHub_App.LANG.ADD_EDIT_RESOURCE = 'Add / Edit Resource';
    CrowdHub_App.LANG.ADD_EDIT_QUESTION = 'Add / Edit Question';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_RESOURCE = 'Add Resource';
    CrowdHub_App.LANG.EDIT_CONTENT_DELETE = 'Delete';
    CrowdHub_App.LANG.EDIT_CONTENT_SAVE_CHANGES = 'Save Changes';
    CrowdHub_App.LANG.EDIT_CONTENT_CANCEL = 'Cancel';
    CrowdHub_App.LANG.EDIT_CONTENT_SAVED = 'Saved!';
    CrowdHub_App.LANG.EDIT_CONTENT_EDIT = 'Edit';
    CrowdHub_App.LANG.EDIT_CONTENT_DATES = 'Dates';
    CrowdHub_App.LANG.EDIT_CONTENT_STARTDATE = 'Start Date (Local Time)';
    CrowdHub_App.LANG.EDIT_CONTENT_ENDDATE = 'End Date (Local Time)';
    CrowdHub_App.LANG.EDIT_CONTENT_RELEASEDATE = 'Release Date (Local Time)';
    CrowdHub_App.LANG.EDIT_CONTENT_CERTIFICATE_INFO = 'Certificate Information';
    CrowdHub_App.LANG.EDIT_CONTENT_REWARD_CERT = 'Reward Certificate Upon Completion';
    CrowdHub_App.LANG.EDIT_CONTENT_CERTIFICATE_IMAGE = 'Certificate Image';
    CrowdHub_App.LANG.EDIT_CONTENT_REQUIRE_COMPLETION = 'Requires the completion of a Specified Track';
    CrowdHub_App.LANG.EDIT_CONTENT_NO_PRERECORDED = 'No Pre-Recorded Video';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY = 'Attendance Criteria';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_RESTRICT_ACCESSLEVEL = 'Restrict Attendees by Access Level';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_RESTRICT_ACCESSLEVEL_INFO =
      'Select the participant access levels tags that will be allowed access to this session.';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_ATTEND_PREREQ = 'Specify Attendance Prerequisite(s)';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_ATTEND_PREREQ_INFO = `Choose which sessions must be added to the participant's schedule prior to allowing this session to be scheduled.`;
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_ATTEND_PREREQ_BTN = 'Select Required Session(s)';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_EXCLUSIVE_SESSION = 'Classify Session as "Exclusive"';
    CrowdHub_App.LANG.EDIT_CONTENT_ELIGIBILITY_EXCLUSIVE_SESSION_INFO =
      'When enabled, participants can’t schedule other sessions that overlap with this time block and are also classified as "Exclusive."';

    CrowdHub_App.LANG.LABEL_COMPLETEDPERCENTAGE = 'Complete';

    CrowdHub_App.LANG.BUTTON_BOOKNOW = 'Schedule';
    CrowdHub_App.LANG.BUTTON_TALKNOW = 'Talk Now';
    CrowdHub_App.LANG.BUTTON_CHATNOW = 'Message';

    CrowdHub_App.LANG.CONVO_LIST_PARTNER_TAG = 'Partner';

    CrowdHub_App.LANG.CHAT_REQUEST_PENDING = 'would like to chat'; // this string starts with the user's firstname
    CrowdHub_App.LANG.CHAT_REQUEST_AUTO_ACCEPTED = 'has sent you a message'; // this string starts with the user's firstname
    CrowdHub_App.LANG.EXHIBITOR_CHAT_TAG = 'Exhibitor';

    CrowdHub_App.LANG.EDIT_CONTENT_ADD_OR_UPDATE = 'Add or Update';
    CrowdHub_App.LANG.EDIT_CONTENT_UPLOAD_FILE = 'Upload File';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_QUESTION = 'Add Question';
    CrowdHub_App.LANG.EDIT_CONTENT_ADDRESS = 'Address';
    CrowdHub_App.LANG.EDIT_CONTENT_INTRO = 'Intro';
    CrowdHub_App.LANG.EDIT_CONTENT_DESCRIPTION = 'Description';
    CrowdHub_App.LANG.EDIT_CONTENT_ICON = 'Icon';
    CrowdHub_App.LANG.EDIT_CONTENT_PARTNER_HEADER_BACKGROUND = 'Partner Header Background';
    CrowdHub_App.LANG.EDIT_CONTENT_PARTNER_SPECIFICS_BACKGROUND = 'Partner Specifics Background';
    CrowdHub_App.LANG.EDIT_CONTENT_ATTACH_SESSION = 'Attach Session';
    CrowdHub_App.LANG.EDIT_CONTENT_REMOVE_SESSION = 'Remove Session';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_META_DATA = 'Add Meta Data';
    CrowdHub_App.LANG.EDIT_CONTENT_RELEASE_DATE = 'Release Date';
    CrowdHub_App.LANG.EDIT_CONTENT_LISTIMAGE = 'List Image';
    CrowdHub_App.LANG.EDIT_CONTENT_BANNERIMAGE = 'Banner Image';
    CrowdHub_App.LANG.EDIT_CONTENT_EXTRASIMAGE = 'Pre Session Information Banner';
    CrowdHub_App.LANG.EDIT_CONTENT_DATES = 'Dates';
    CrowdHub_App.LANG.EDIT_CONTENT_IMAGES = 'Images';
    CrowdHub_App.LANG.EDIT_CONTENT_VIDEO_DESCRIPTION = 'Best for realtime audiences under 3000';
    CrowdHub_App.LANG.EDIT_CONTENT_BROADCAST_DESCRIPTION = 'Best for semi-realtime audiences under 100,000';
    CrowdHub_App.LANG.EDIT_CONTENT_PRERECORDED_DESCRIPTION = 'Best for when your stream is pre-recorded';
    CrowdHub_App.LANG.EDIT_CONTENT_BREAKOUT_DESCRIPTION = 'Anyone can join and share their cameras';
    CrowdHub_App.LANG.EDIT_CONTENT_PANEL_DESCRIPTION =
      'Only representatives tagged as panelists can join and share their cameras';
    CrowdHub_App.LANG.EDIT_CONTENT_MAINSTAGE_DESCRIPTION =
      'Only representatives tagged as main stage can join and share their cameras';
    CrowdHub_App.LANG.EDIT_CONTENT_CUSTOM_DESCRIPTION =
      'Only representatives added below are able to join and share their cameras';
    CrowdHub_App.LANG.EDIT_CONTENT_CONTENT_BROWSER = 'Content Browser';
    CrowdHub_App.LANG.EDIT_CONTENT_RULES = 'Rules';
    CrowdHub_App.LANG.EDIT_CONTENT_SOCIAL_INFORMATION = 'Social Information';
    CrowdHub_App.LANG.EDIT_CONTENT_SITE_NAME = 'Site Name';
    CrowdHub_App.LANG.EDIT_CONTENT_META_NAME = 'Site Share Name';
    CrowdHub_App.LANG.EDIT_CONTENT_SITE_META_DESCRIPTION = 'Site Share Description';
    CrowdHub_App.LANG.EDIT_CONTENT_SITE_SHARE_IMAGE = 'Site Share Image';
    CrowdHub_App.LANG.EDIT_CONTENT_HAS_ADMIN_RIGHTS = 'Has Admin Rights';
    CrowdHub_App.LANG.EDIT_CONTENT_BAN_MEMBER = 'Ban Member';
    CrowdHub_App.LANG.EDIT_CONTENT_UNBAN_MEMBER = 'Unban Member';
    CrowdHub_App.LANG.EDIT_CONTENT_DOWNLOAD_HISTORY = 'Download History';
    CrowdHub_App.LANG.EDIT_CONTENT_VIEW_PROFILE = 'View Profile';
    CrowdHub_App.LANG.EDIT_CONTENT_INVITE_USER = 'Invite a user to the platform';
    CrowdHub_App.LANG.EDIT_CONTENT_INVITE_USERS = 'Invite Member';
    CrowdHub_App.LANG.EDIT_CONTENT_PREVIOUS_INVITES = 'Previous Invites';
    CrowdHub_App.LANG.EDIT_CONTENT_BRANDING = 'Branding';
    CrowdHub_App.LANG.EDIT_CONTENT_SIZING = 'Sizing';
    CrowdHub_App.LANG.EDIT_CONTENT_TEXT_COLORS = 'Text Colors';
    CrowdHub_App.LANG.EDIT_CONTENT_BACKGROUND_COLORS = 'Background Colors';
    CrowdHub_App.LANG.EDIT_CONTENT_IMAGES = 'Images';
    CrowdHub_App.LANG.EDIT_CONTENT_SWITCHES = 'Switches';
    CrowdHub_App.LANG.LESSON_BREAKDOWN_HEADER = 'Lesson Breakdown';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_CONTENT = 'Add Content';
    CrowdHub_App.LANG.EDIT_CONTENT_ADD_CONTENT_TITLE = 'Add Content';

    CrowdHub_App.LANG.EDITSITE_OTSESSION_DESCRIPTION = 'A live, interactive video session or breakout room';
    CrowdHub_App.LANG.EDITSITE_PARTNER_DESCRIPTION =
      'A virtual booth for site exhibitors to fill out with their own content and interact with attendees';
    CrowdHub_App.LANG.EDITSITE_SPEAKER_DESCRIPTION = 'A page to add more information about a speaker or VIP';
    CrowdHub_App.LANG.EDITSITE_TRACK_DESCRIPTION =
      'A group of lessons that attendees can use for learning and certification';
    CrowdHub_App.LANG.EDITSITE_LIBRARY_DESCRIPTION = 'An on-demand video, blog or article';
    CrowdHub_App.LANG.EDITSITE_ANALYTICS_OVERTHRESHOLD_WARNING =
      '* For optimal query results, please keep your date range limited to one month';
    CrowdHub_App.LANG.EDITSITE_ANALYTICS_DATE_RANGE = 'Date Range:';

    CrowdHub_App.LANG.EDITSITE_ANALYTICS_DATE_DAY = 'TODAY';
    CrowdHub_App.LANG.EDITSITE_ANALYTICS_DATE_WEEK = 'ONE WEEK';
    CrowdHub_App.LANG.EDITSITE_ANALYTICS_DATE_MONTH = 'ONE MONTH';
    CrowdHub_App.LANG.EDITSITE_ANALYTICS_DATE_ALLTIME = 'ALL TIME';

    CrowdHub_App.LANG.ANALYTICS_CHECK_IN_USERS = 'Check-In Users';
    CrowdHub_App.LANG.ANALYTICS_REGISTERED_USERS = 'Registered Users';
    CrowdHub_App.LANG.ANALYTICS_ENGAGED_USERS_VS_TOTAL_USERS = 'Unique Engaged Users / Total Unique Users';
    CrowdHub_App.LANG.ANALYTICS_TOTAL_PROFILES = 'Total Profiles';
    CrowdHub_App.LANG.ANALYTICS_NEW_USERS = 'New Users';

    // CrowdHub_App.LANG.EDITSITE_RESOURCE_DESCRIPTION = "A helpful article used for tips or information";

    CrowdHub_App.LANG.MY_PROFILE_TITLE = 'My Profile';

    CrowdHub_App.LANG.STATISTICS = 'Statistics';

    CrowdHub_App.LANG.PUBNUB_CHATREQUESTTEXT = '*|FIRSTNAME|* would like to chat';
    CrowdHub_App.LANG.PUBNUB_NOCHATHISTORY = 'This is the start of your conversation with *|FIRSTNAME|*';
    CrowdHub_App.LANG.PUBNUB_NOTACCEPTED = '*|FIRSTNAME|* has not yet accepted your request.';
    CrowdHub_App.LANG.PUBNUB_INVITATIONSENT = 'Chat Invitation Sent';

    CrowdHub_App.LANG.PUBLISHING_DESKTOP = 'Publishing Your Desktop';

    CrowdHub_App.LANG.LINK_COPIED = 'Profile link copied!';

    CrowdHub_App.LANG.AUDIO_VOLUME_VIMEO = 'Tap the volume controls on the bottom right to adjust player volume';

    CrowdHub_App.LANG.MODERATOR_BUTTON_DELETEQUESTION = 'Remove Question';
    CrowdHub_App.LANG.MODERATOR_BUTTON_SHOWQUESTIONCOUNTDOWN = 'Show Countdown';
    CrowdHub_App.LANG.MODERATOR_BUTTON_SHOWQUESTIONRESULT = 'End Question';

    CrowdHub_App.LANG.PEOPLELIKE_ONE = '*|NUM|* person likes this';
    CrowdHub_App.LANG.PEOPLELIKE_NOT_ONE = '*|NUM|* people like this';

    CrowdHub_App.LANG.PROFILE_TAGS = 'Tags';
    CrowdHub_App.LANG.PROFILE_INFORMATION = 'Information';

    CrowdHub_App.LANG.WRITE_REVIEW = 'Write a Review';
    CrowdHub_App.LANG.UP_NEXT = 'Up Next';
    CrowdHub_App.LANG.ANALYTICS_HEADER = 'Analytics';
    CrowdHub_App.LANG.ANALYTICSFOR = 'Choose Time Frame';
    CrowdHub_App.LANG.ANALYTICSRESULT = 'Results';
    CrowdHub_App.LANG.ANALYTICSONLYADMINS = 'Only admins can see this data';
    CrowdHub_App.LANG.UP_TALK_WITH_OUR_TEAM = 'TALK WITH OUR TEAM';
    CrowdHub_App.LANG.DONT_MISS_SESSIONS = "DON'T MISS SESSIONS";
    CrowdHub_App.LANG.DONT_MISS_SESSIONS_DESC = 'Join us in other events';
    CrowdHub_App.LANG.CONNECT_WITH_US = 'CONNECT WITH US';
    CrowdHub_App.LANG.RESOURCES = 'RESOURCES';
    CrowdHub_App.LANG.PRODUCTS = 'PRODUCTS';
    CrowdHub_App.LANG.VISIT_WEBSITE = 'VISIT WEBSITE';
    CrowdHub_App.LANG.LIKE_SINGULAR = 'Like';
    CrowdHub_App.LANG.LIKE_MULTIPLE = 'Likes';
    CrowdHub_App.LANG.LIKE_LIST_NO_RESULTS = 'No representatives have liked this';
    CrowdHub_App.LANG.ATTENDING_LIST_NO_RESULTS = 'No representatives Attending';

    CrowdHub_App.LANG.NUM_VOTES_S = '*|COUNT|* votes';
    CrowdHub_App.LANG.NUM_VOTES = '*|COUNT|* vote';

    CrowdHub_App.LANG.NO_LEADERBOARD_RESULTS = 'No Results';

    CrowdHub_App.LANG.RESOURCES_LEARN_MORE = 'Learn more in our digital resource library';
    CrowdHub_App.LANG.VIEW_SESSION = 'VIEW SESSION';
    CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT = 'Schedule a time to chat';
    CrowdHub_App.LANG.SHEDULE_A_MEETING_TEXT = 'Schedule a meeting with ';
    CrowdHub_App.LANG.LANDING_WELCOMETO = 'WELCOME TO';
    CrowdHub_App.LANG.PLACEHOLDER_ADDCOMMENTS = 'Type Here';
    CrowdHub_App.LANG.COMMENTS_TITLE = 'Comments';
    CrowdHub_App.LANG.COMMENTS_PLACEHOLDER = 'Add Comment';
    CrowdHub_App.LANG.COMMENTS_BUTTON = 'Add Comment';
    CrowdHub_App.LANG.COMMENTS_DELETE_CONFIRMATION = 'Are you sure you want to delete this comment?';

    CrowdHub_App.LANG.BASIC_INFORMATION = 'Basic Information';

    CrowdHub_App.LANG.SESSION_AT_CAPACITY = 'Session is at capacity';
    CrowdHub_App.LANG.SESSION_LOGIN_TO_VIEW = 'Please login to view this session!';

    CrowdHub_App.LANG.COMPLETE_YOUR_PROFILE =
      "Welcome back, *|FIRSTNAME|*.  Complete your <span class='brand_color_color'>profile</span> to be more visible on the site!";

    CrowdHub_App.LANG.TITLE_ATTACHMENTS = 'Downloads';
    CrowdHub_App.LANG.TITLE_ENTERMESSAGE = 'Send a message to <span>*|FIRSTNAME|* *|LASTNAME|*</span>';

    CrowdHub_App.LANG.TITLE_SCHEDULEMEETING = 'Schedule a meeting with <span>*|FIRSTNAME|* *|LASTNAME|* </span>';
    CrowdHub_App.LANG.TITLE_RESCHEDULEMEETING = 'Reschedule your meeting with <span>*|FIRSTNAME|* *|LASTNAME|* </span>';
    CrowdHub_App.LANG.PRIVATE_MEETING_NAME = 'A Meeting with *|FIRSTNAME|* *|LASTNAME|*';
    CrowdHub_App.LANG.PRIVATE_MEETING_USER = '*|FIRSTNAME|* *|LASTNAME|* has requested a Meeting.';
    CrowdHub_App.LANG.TITLE_ADDBLACKOUTDATE = 'Add an away date for <span>*|FIRSTNAME|* *|LASTNAME|* </span>';
    CrowdHub_App.LANG.PRIVATE_PARTNER_MEETING_NAME = '*|USERCOMPANY|* scheduled a meeting with *|PARTNERCOMPANY|*';
    CrowdHub_App.LANG.PRIVATE_PARTNER_MEETING_DESCRIPTION = '';

    CrowdHub_App.LANG.TITLE_LINKS = 'Links';
    CrowdHub_App.LANG.HIGH_CONTRAST = 'High contrast';
    CrowdHub_App.LANG.PROFILE = 'Profile';

    CrowdHub_App.LANG.CANCEL_MEETING = 'Cancel Meeting';

    // Pubnub chat popup
    CrowdHub_App.LANG.BLOCKED_USERS_MODAL_TITLE = 'Blocked users';
    CrowdHub_App.LANG.BLOCKED_USERS_MODAL_NO_RESULTS = "You haven't blocked any users";
    CrowdHub_App.LANG.CONVERSATIONS_PANEL_TITLE = 'Messages';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_MUTE = 'Mute User';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_REPORT_USER = 'Report User';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_BLOCK_USER = 'Block user';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_UNBLOCK_USER = 'Unblock user';
    CrowdHub_App.LANG.CONVERSATION_DECLINED = 'has declined the conversation';

    CrowdHub_App.LANG.CONVERSATIONS_PANEL_EMPTY_PREPEND = 'You currently have no messages.';

    CrowdHub_App.LANG.UNBLOCK_USER = 'Unblock';

    CrowdHub_App.LANG.CONVERSATION_SETTINGS_LEAVE = 'Leave Conversation';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_CANCEL = 'Cancel';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_TITLE = 'Settings';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_REPORT_CONFIRM_TITLE = 'Report this user?';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_BLOCK_CONFIRM_TITLE = 'Block this user?';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_UNBLOCK_CONFIRM_TITLE = 'Unblock this user?';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_SUBTITLE = '';
    CrowdHub_App.LANG.CONVERSATION_SETTINGS_BLOCK_SUBTITLE =
      "They won't be able to contact you and your conversation will be hidden. They can still see your profile, but it will say you're offline. They won't be notified you blocked them.<br><br>You can manage your blocked users list from your profile page.";

    CrowdHub_App.LANG.UNBLOCK_USER_CONFIRMATION =
      "They'll be able to message and schedule meetings with you. Any conversation history will reappear. They will not be notified when you unblocked them.";
    CrowdHub_App.LANG.UNBLOCK_USER_CONFIRMATION_TITLE = 'User Unblocked!';
    CrowdHub_App.LANG.MANAGE_BLOCKED_USERS = 'Manage Blocked Users';

    CrowdHub_App.LANG.TRACK_COMPLETED = 'Track Completed!';
    CrowdHub_App.LANG.TRACK_READY_TO_BEGIN = 'Ready to Begin!';
    CrowdHub_App.LANG.TRACK_IN_PROGRESS = 'Course In Progress';
    CrowdHub_App.LANG.TRACK_COMPLETED_BUT_EXPIRED = 'Time has expired!';
    CrowdHub_App.LANG.TRACK_START_COURSE = 'START COURSE';
    CrowdHub_App.LANG.TRACK_BACK_TO_COURSES = 'BACK TO COURSES';

    CrowdHub_App.LANG.CLICK_TO_JOIN = 'Join';

    CrowdHub_App.LANG.LEAVE_CONFIRM_TITLE = 'Are you sure you want to leave?';
    CrowdHub_App.LANG.LEAVE_CONFIRM_PUBLISHER_DESCRIPTION =
      'Would you like to continue watching the session or return to the home page?';
    CrowdHub_App.LANG.LEAVE_CONFIRM_WATCHER_DESCRIPTION = 'You will be returned to the home page.';
    CrowdHub_App.LANG.LEAVE_CONFIRM_CONTINUEWATCHING_BUTTON_TEXT = 'Continue Watching';
    CrowdHub_App.LANG.LEAVE_CONFIRM_RETURNHOME_BUTTON_TEXT = 'Return Home';
    CrowdHub_App.LANG.LEAVE_CONFIRM_CANCEL_BUTTON_TEXT = 'Nevermind, cancel';

    CrowdHub_App.LANG.NOMEMBERS_CANPUBLISH_TITLE = "You're the first!";
    CrowdHub_App.LANG.NOMEMBERS_CANPUBLISH_DESCRIPTION =
      'Be the first to join the session by tapping the video icon below! Other representatives will join soon!';

    CrowdHub_App.LANG.NOMEMBERS_PREROLL_STARTING_TITLE = 'Preroll is starting soon.';
    CrowdHub_App.LANG.NOMEMBERS_PREROLL_STARTING_DESCRIPTION =
      'Please wait. This session has a preroll which will be starting soon.';

    CrowdHub_App.LANG.NOMEMBERS_CANNOTPUBLISH_TITLE = 'Session Starting Soon';
    CrowdHub_App.LANG.NOMEMBERS_CANNOTPUBLISH_DESCRIPTION =
      'No streamers have joined yet. Retrying in *|TIMER|* seconds';
    CrowdHub_App.LANG.NOMEMBERS_CANNOTPUBLISH_DESCRIPTION_NOTIMER = 'No streamers have joined yet.';

    CrowdHub_App.LANG.NONLIVE_STREAM_TITLE = 'Session Starting Soon';
    CrowdHub_App.LANG.NONLIVE_STREAM_DESCRIPTION = 'The video will begin in *|TIMER|* seconds';

    CrowdHub_App.LANG.NONLIVE_STREAM_HEADER = 'Session Starting Soon';
    CrowdHub_App.LANG.NONLIVE_STREAM_FOOTER = 'This session begins in';
    CrowdHub_App.LANG.NONLIVE_STREAM_BODY = '*|SECONDS|* Seconds';

    CrowdHub_App.LANG.CANNOT_ANSWER_QUESTIONS = 'This form is locked because it was already completed';

    CrowdHub_App.LANG.REGISTER_COMPLETE_CTA = "Let's Go!";

    CrowdHub_App.LANG.NOMEMBERS_JOINNOW = 'Join Now';

    CrowdHub_App.LANG.LANDING_LOGIN_BUTTON = 'LOGIN';
    CrowdHub_App.LANG.ACCOUNT_UPDATE_BUTTON = 'UPDATE';

    CrowdHub_App.LANG.LANDING_JOIN_BUTTON = 'JOIN TODAY';
    CrowdHub_App.LANG.LANDING_LEARN_BUTTON = 'LEARN MORE';
    CrowdHub_App.LANG.LANDING_ALREADY_HAVE_ACCOUNT =
      'Already Have an Account? <span aria-label="Login with current account" tabindex="0" role="button"><strong>Login Here</strong></span>';

    CrowdHub_App.LANG.FILTERS_BUTTON = 'Filters';
    CrowdHub_App.LANG.VISITWEBSITE_BUTTON = 'Visit Website';

    CrowdHub_App.LANG.MOREINFO_BUTTON = 'More Info';
    CrowdHub_App.LANG.VIEWSPEAKER_BUTTON = 'Visit Page';
    CrowdHub_App.LANG.VIEWPARTNER_BUTTON = 'Visit Page';

    CrowdHub_App.LANG.FILTERS_TITLE = 'Filters';
    CrowdHub_App.LANG.APPLY_BUTTON = 'Apply';
    CrowdHub_App.LANG.CLEARFILTERS_BUTTON = 'Clear All';

    CrowdHub_App.LANG.SENDMESSAGE_DISCLAIMER = '*Your email will be shared with the recepient.';

    CrowdHub_App.LANG.WARNING_PASTEVENT = 'This event has passed';
    CrowdHub_App.LANG.WARNING_FULLEVENT = 'This event is full';

    CrowdHub_App.LANG.CALL_REFUSED = '*|NAME|* is busy, try again later!';

    CrowdHub_App.LANG.MAINCOUNTDOWN_TIMER_TEXT = 'Conference begins in <strong>*|TIMER|*</strong>';
    CrowdHub_App.CONFIG.MAIN_TIMER_COUNTDOWN = '2020-08-18 00:00:00'; // delays/timers

    CrowdHub_App.LANG.SCOREBOARD_COUNTDOWN_TEXT = '<strong>*|TIMER|*</strong>';

    CrowdHub_App.LANG.LEADERBOARD_HEADER_TITLE = 'Leaderboard';

    CrowdHub_App.LANG.USER_ROOM_INFO =
      'Every user has their own video conference/office/meeting room.<br>They can invite whoever they want here by giving them the URL.<br>Your meeting room is *|url|*.<br>Share this URL with your contacts to have a personal meeting.';

    CrowdHub_App.LANG.YOUR_LINK_LABEL = 'Your profile link';

    CrowdHub_App.LANG.CLEARALL_BUTTON = 'Clear All';
    CrowdHub_App.LANG.SAVE_BUTTON = 'Save';
    CrowdHub_App.LANG.LOGOUT_BUTTON = 'Logout';
    CrowdHub_App.LANG.CANCEL_BUTTON = 'Cancel';
    CrowdHub_App.LANG.ALLOW_NOTIFICATIONS_BUTTON = 'Send Notifications';
    CrowdHub_App.LANG.UPDATE_MEETING_BUTTON = 'Update Meeting';

    CrowdHub_App.LANG.SCHEDULE_MEETING_BUTTON = 'Schedule Meeting';
    CrowdHub_App.LANG.VIEW_DETAILS_BUTTON = 'View Details';
    CrowdHub_App.LANG.SEND_BUTTON = 'Send';
    CrowdHub_App.LANG.SENDINVITE_BUTTON = 'Send Invite';
    CrowdHub_App.LANG.CANCEL_BUTTON = 'Cancel';
    CrowdHub_App.LANG.SEND_MESSAGE_BUTTON = 'Send a Message';
    CrowdHub_App.LANG.CHAT_USER_BUTTON = 'Send a Message';
    CrowdHub_App.LANG.QUICKCHAT_USER_BUTTON = 'Send Message';
    CrowdHub_App.LANG.QUICKCHAT_VIEW_PROFILE_BUTTON = 'View Full Profile';

    CrowdHub_App.LANG.SPEAKER_PREROLL_TOASTR_HEADER = 'Others are still watching the preroll video.';
    CrowdHub_App.LANG.SPEAKER_PREROLL_TOASTR_BODY = '*|SECONDS|* Seconds';
    CrowdHub_App.LANG.SPEAKER_PREROLL_TOASTR_FOOTER = 'This session begins in';

    CrowdHub_App.LANG.DECLINED_MEETING = 'You have declined this meeting!';

    CrowdHub_App.LANG.BLOCKED_USER_ALERT = 'You have successfully blocked this user!';
    CrowdHub_App.LANG.REPORTED_USER_ALERT = 'User Reported To Moderator!';

    CrowdHub_App.LANG.SAVE_INPUTS_BUTTON = 'Save';

    CrowdHub_App.LANG.ADD_BLACKOUT_DATE_BUTTON = 'Add Away Date';

    CrowdHub_App.LANG.CANNOT_BE_CONTACTED = '*|FIRSTNAME|* prefers not to be contacted';

    CrowdHub_App.LANG.MAY_TAKE_AWHILE = 'May take a while, please be patient';

    CrowdHub_App.LANG.YES_BUTTON = 'Yes';
    CrowdHub_App.LANG.NO_BUTTON = 'No';
    CrowdHub_App.LANG.SNOOZE_BUTTON = 'Snooze';

    CrowdHub_App.LANG.DOWNLOAD_HEADER = 'Downloads';
    CrowdHub_App.LANG.ARCHIVE_HEADER = 'Archives';
    CrowdHub_App.LANG.DOWNLOAD_ACTIVITY_BUTTON = 'Activity Log';
    CrowdHub_App.LANG.DOWNLOAD_USERS_BUTTON = 'Unique Users';
    CrowdHub_App.LANG.DOWNLOAD_RESPONSES = 'Poll Responses';
    CrowdHub_App.LANG.DOWNLOAD_DOWNLOADS = 'Download Log';
    CrowdHub_App.LANG.DOWNLOAD_META = 'Click Log';
    CrowdHub_App.LANG.DOWNLOAD_COMMENTS = 'Comments Log';
    CrowdHub_App.LANG.DOWNLOAD_QA = 'Q&A Log';
    CrowdHub_App.LANG.DOWNLOAD_USER_PROGRAM_PROGRESS = 'User Program Progress Log';
    CrowdHub_App.LANG.DOWNLOAD_COURSE_WEIGHTS = 'Course Weights Log';

    CrowdHub_App.LANG.DOWNLOAD_CERTIFICATE = 'Download Certificate';
    CrowdHub_App.LANG.VIEW_CERTIFICATE = 'View Certificate';

    CrowdHub_App.LANG.NO_AVAILABLE_TIMES =
      'There are no more time blocks available for this day. Please choose another day.';

    CrowdHub_App.LANG.TAP_TO_JOINVIDEO = 'Tap to join live broadcast';
    CrowdHub_App.LANG.TAP_TO_PLAYVIDEO = 'Tap to play';

    CrowdHub_App.LANG.ACCOUNT_GET_STARTED = 'Get Started';
    CrowdHub_App.LANG.ACCOUNT_CREATE_YOUR_ACCOUNT = 'Create Your Account';
    CrowdHub_App.LANG.ACCOUNT_CONTINUE_BTN = 'Login';

    CrowdHub_App.LANG.CREATE_ACCOUNT = 'Create Account';
    CrowdHub_App.LANG.UPDATE_ACCOUNT = 'Finish Creating Your Account';

    CrowdHub_App.LANG.CHOOSE_VIDEO_SOURCE = 'Choose Video Source';
    CrowdHub_App.LANG.CHOOSE_AUDIO_SOURCE = 'Choose Audio Source';
    CrowdHub_App.LANG.CHOOSE_OUTPUT_SOURCE = 'Choose Output';
    CrowdHub_App.LANG.CHANGE_INPUTS = 'Settings';

    CrowdHub_App.LANG.ON_CHANNEL_NAME = 'On channel *|NAME|*';

    CrowdHub_App.LANG.MODERATOR_STREAM_TITLE = 'Stream Settings';
    CrowdHub_App.LANG.MODERATOR_POLLHASENDED = 'This Poll Has Ended';

    CrowdHub_App.LANG.QA_ASKQUESTION = '*|NAME|* Asked:';
    CrowdHub_App.LANG.QA_ANSWERQUESTION = '*|NAME|* Replied:';
    CrowdHub_App.LANG.QA_RAISEDHAND = '*|NAME|* raised their hand';
    CrowdHub_App.LANG.SEND_ANONYMOUSLY = 'Ask Anonymously';
    CrowdHub_App.LANG.SEND_ANONYMOUSLY_TOOLTIP = 'Submits your question without your name or profile image.';

    CrowdHub_App.LANG.TAGGED_IN_POST_LINE = '*|NAME|* was tagged';
    CrowdHub_App.LANG.TAGGEDMULTIPLE_IN_POST_LINE = '*|NAME|* +*|COUNT|* were tagged';

    CrowdHub_App.LANG.QA_SUBMITTED_TAB = 'Submitted';
    CrowdHub_App.LANG.QA_POSTED_TAB = 'Posted';
    CrowdHub_App.LANG.POST_QUESTION_BUTTON = 'Post Question';
    CrowdHub_App.LANG.ASK_PRESENTER_BUTTON = 'Ask Presenter';
    CrowdHub_App.LANG.QA_ANSWERED_FLAG = 'Answered';
    CrowdHub_App.LANG.QA_PRESENTER_ASKED_FLAG = 'Presenter Asked';
    CrowdHub_App.LANG.QA_ANSWERED_LIVE_FLAG = 'Answered Live';
    CrowdHub_App.LANG.QA_QUESTION_SUBMITTED = 'Thank you, your question has been submitted!';

    CrowdHub_App.LANG.STREAMFROMHAND_INSTRUCTIONS =
      "You have been placed into the conference. Tap 'Start Streaming' to begin streaming. Tap 'Stop Streaming' when you are finished.";
    CrowdHub_App.LANG.BUTTON_STARTRAISEHANDSTREAM = 'Start Streaming';
    CrowdHub_App.LANG.BUTTON_STOPRAISEHANDSTREAM = 'Stop Streaming';
    CrowdHub_App.LANG.BUTTON_CANCELRAISEHANDSTREAM = 'Cancel';

    CrowdHub_App.LANG.ACCOUNT_GO_BACK = 'Go Back';
    CrowdHub_App.LANG.ACCOUNT_UPLOAD_YOUR_AVATAR = 'Upload Your Avatar';
    CrowdHub_App.LANG.ACCOUNT_CHOOSE_YOUR_TITLE = 'Choose Your Title';
    CrowdHub_App.LANG.ACCOUNT_CHOOSE_YOUR_INTERESTS = 'Choose Your Interests';
    CrowdHub_App.LANG.ACCOUNT_ADDITIONAL_INFORMATION = 'Additional Information';

    CrowdHub_App.LANG.ACCOUNT_AVAILIBILITY = 'My Availability';
    CrowdHub_App.LANG.ACCOUNT_BLACKOUTDATES = 'Away Dates';
    CrowdHub_App.LANG.ACCOUNT_BLACKOUTDATES_NONEADDED = 'No away dates added';
    CrowdHub_App.LANG.ACCOUNT_ADD_DATE = 'Add New Date';
    CrowdHub_App.LANG.ACCOUNT_ACCEPT_TERMS = 'Please accept our privacy policy and terms of service';
    CrowdHub_App.LANG.ACCOUNT_GENERIC_ERROR = 'Please complete all fields';
    CrowdHub_App.LANG.ACCOUNT_LOGINTITLE = 'Login';
    CrowdHub_App.LANG.ACCOUNT_LOGINSUBTITLE = 'Login with your email and password.';
    CrowdHub_App.LANG.ACCOUNT_FORGOTPASSWORD =
      "Forgot your password? <span class='brand_color_color'>Click here</span>";
    CrowdHub_App.LANG.ACCOUNT_FORGOTPASSWORD_COMPLETE = 'Password reset! Check your email for more information.';
    CrowdHub_App.LANG.ACCOUNT_MAGICLINK_COMPLETE = 'Check your email for your magic link.';
    CrowdHub_App.LANG.ACCOUNT_CREATENEW = "Don't have an account?  <span class='brand_color_color'>Click here</span>";
    CrowdHub_App.LANG.ACCOUNT_MAGIC_PAGE_CREATENEW =
      "Don't have an account?  <span tabindex='0' aria-label='create account' class='brand_color_color'>Create an account</span>";
    CrowdHub_App.LANG.ACCOUNT_FORGOTTITLE = 'Forgot Your Password?';
    CrowdHub_App.LANG.ACCOUNT_FORGOTSUBTITLE = 'Enter your email to have your password reset!';
    CrowdHub_App.LANG.ACCOUNT_BUILD_PROFILE = 'Help us build out your profile #FIRSTNAME#';
    CrowdHub_App.LANG.ACCOUNT_COMPANY = 'What company do you work for?';
    CrowdHub_App.LANG.ACCOUNT_LOGIN_WITH_MAGIC_LINK =
      "<span tabindex='0' aria-label='Login with magic link'>Login with email and magic link</span>";

    CrowdHub_App.LANG.BECAME_OFFLINE =
      'It looks like your connection is unstable, please check that you are still connected to the internet.';

    CrowdHub_App.LANG.BREAKOUTS_RECOMMENDED_TITLE = 'Recommended for you';
    CrowdHub_App.LANG.BREAKOUTS_ALL_TITLE = 'All Breakouts';
    CrowdHub_App.LANG.BREAKOUTS_DUPLICATE_TAB_ERROR_TITLE = 'Oops';
    CrowdHub_App.LANG.BREAKOUTS_DUPLICATE_TAB_ERROR_MESSAGE = 'You are already in this breakout in another tab';
    CrowdHub_App.LANG.ALREADY_BOOKED = 'Sorry, this timeslot was just booked! Please choose another.';

    CrowdHub_App.LANG.STREAMCONTROLS_AUDIO = 'Audio';
    CrowdHub_App.LANG.STREAMCONTROLS_AUDIO_TOOLTIP = 'Microphone';
    CrowdHub_App.LANG.STREAMCONTROLS_VIDEO = 'Video';
    CrowdHub_App.LANG.STREAMCONTROLS_VIDEO_TOOLTIP = 'Camera';
    CrowdHub_App.LANG.STREAMCONTROLS_SCREENSHARE = 'Share';
    CrowdHub_App.LANG.STREAMCONTROLS_SCREENSHARE_TOOLTIP = 'Screen Share';
    CrowdHub_App.LANG.STREAMCONTROLS_WHITEBOARD = 'Share Whiteboard';

    CrowdHub_App.LANG.STREAMCONTROLS_RAISEHAND = 'Join';
    CrowdHub_App.LANG.STREAMCONTROLS_RAISEHAND_TOOLTIP = 'Ask to Speak';
    CrowdHub_App.LANG.STREAMCONTROLS_ENTER_FULLSCREEN = 'Enter Full Screen';
    CrowdHub_App.LANG.STREAMCONTROLS_EXIT_FULLSCREEN = 'Exit Full Screen';
    CrowdHub_App.LANG.STREAMCONTROLS_FULLSCREEN_TOOLTIP = 'Full Screen';

    CrowdHub_App.LANG.STREAMCONTROLS_SETTINGS = 'Settings';

    CrowdHub_App.LANG.STREAMCONTROLS_HELP = 'Request Help';
    CrowdHub_App.LANG.STREAMCONTROLS_LEAVE = 'Leave';
    CrowdHub_App.LANG.STREAMCONTROLS_MORE = 'More';

    CrowdHub_App.LANG.STREAMCONTROLS_MUTEALL = 'Mute All';
    CrowdHub_App.LANG.STREAMCONTROLS_STOPALL = 'Stop All';
    CrowdHub_App.LANG.STREAMCONTROLS_MODERATE = 'Moderate';
    CrowdHub_App.LANG.STREAMCONTROLS_DETAILS = 'Details';

    CrowdHub_App.LANG.STREAMCONTROLS_SMART = 'Smart';
    CrowdHub_App.LANG.STREAMCONTROLS_GRID = 'Grid';
    CrowdHub_App.LANG.STREAMCONTROLS_PIN = 'Speaker';

    CrowdHub_App.LANG.STREAMCONTROLS_STOPALL_CONFIRM_TITLE = 'Are you sure you want to Stop All?';
    CrowdHub_App.LANG.STREAMCONTROLS_STOPALL_CONFIRM_MESSAGE =
      'This action will end video and audio for all current speakers in the session and send them back to the home page.';
    CrowdHub_App.LANG.STREAMCONTROLS_STOPALL_CONFIRM_OK = 'STOP ALL';
    CrowdHub_App.LANG.STREAMCONTROLS_STOPALL_CONFIRM_CANCEL = 'CANCEL';

    CrowdHub_App.LANG.OT_ERROR_CAMMIC = 'Camera and Microphone access has been denied.';
    CrowdHub_App.LANG.OT_ERROR_NOCAM = 'Could not find any attached webcams.';
    CrowdHub_App.LANG.OT_ERROR_POORQUALITY = 'The quality of your connection is poor.';
    CrowdHub_App.LANG.OT_ERROR_STATISTICS =
      "Unable to get statistics.  Please disable any VPN's or firewalls before connecting to video!";
    CrowdHub_App.LANG.OT_ERROR_STREAMS =
      "Unable to get subscribe to video streams.  Please disable any VPN's or firewalls before connecting to video!";
    CrowdHub_App.LANG.OT_ERROR_BROWSER =
      'It looks like you are trying to use an unsupported browser.  For best results use the latest Chrome, Edge or Safari!';
    CrowdHub_App.LANG.OT_ERROR_OTHERSESSIONURLS =
      "Unable to connect to session urls.  Please disable any VPN's or firewalls and try again! - *|ERROR|*";
    CrowdHub_App.LANG.OT_ERROR_SERVERCONFIG = 'There is a server configuration error - *|ERROR|*';
    CrowdHub_App.LANG.OT_ERROR_MESSAGINGERROR =
      "Unable to connect to messaging urls.  Please disable any VPN's or firewalls and try again! - *|ERROR|*";
    CrowdHub_App.LANG.OT_ERROR_NETWORKERROR =
      "Unable to connect to the session.  Please disable any VPN's or firewalls and try again! - *|ERROR|*";
    CrowdHub_App.LANG.OT_ERROR_CANTSTREAM =
      'We were unable to create a video stream, please ensure your webcam is not being used by another application! - *|ERROR|*';
    CrowdHub_App.LANG.OT_ERROR_CALLBACK =
      "Unable to update on callback.  Please disable any VPN's or firewalls and try again! - *|ERROR|*";
    CrowdHub_App.LANG.OT_ERROR_MEDIADEVICEERROR =
      'We were unable to create a video stream, please ensure your webcam is not being used by another application! - *|ERROR|*';

    // Stream subscription errors
    CrowdHub_App.LANG.SUBSCRIBER_OT_CREATE_PEER_CONNECTION_FAILED =
      "Failed to create a connection between this client and the stream's publisher or the Media Router.";
    CrowdHub_App.LANG.SUBSCRIBER_OT_DISCONNECTED = 'Action failed because you are not connected to the session.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_INVALID_PARAMETER = 'One or more parameters was not valid or not provided.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_ICE_WORKFLOW_FAILED =
      'Something went wrong while establishing WebRTC connectivity.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_MEDIA_ERR_ABORTED =
      'The fetching of the stream for the video element has been aborted.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_MEDIA_ERR_DECODE =
      'A decoding error occurred while trying to play the stream in the video element.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_MEDIA_ERR_NETWORK = 'A network error caused the stream to stop being fetched.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_MEDIA_ERR_SRC_NOT_SUPPORTED =
      'The stream has been detected to be not suitable for playback.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_NOT_CONNECTED =
      "Couldn't perform action because you are not connected to the network.";
    CrowdHub_App.LANG.SUBSCRIBER_OT_SET_REMOTE_DESCRIPTION_FAILED =
      'The WebRTC connection failed during setDescription.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_STREAM_DESTROYED = 'The stream was destroyed before it could be subscribed to.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_STREAM_LIMIT_EXCEEDED =
      'You tried to subscribe to a stream in a session that has exceeded the limit for simultaneous streams.';
    CrowdHub_App.LANG.SUBSCRIBER_OT_STREAM_NOT_FOUND = "Couldn't subscribe to the stream because it was not found.";

    CrowdHub_App.LANG.DEFAULT_DEVICE = 'System Default';
    CrowdHub_App.LANG.NEW_DEVICE_DETECTED_TITLE = 'New *|DEVICE_TYPE|* Device';
    CrowdHub_App.LANG.NEW_DEVICE_DETECTED = 'We found a new device: *|DEVICE|*';
    CrowdHub_App.LANG.NEW_DEVICE_DETECTED_BTN = 'Use this device';

    CrowdHub_App.LANG.OT_SUBSCRIBER_UNKNOWN_ERROR = 'There was an unknown error subscribing to a new stream';
    CrowdHub_App.LANG.OT_PUBLISHER_UNKNOWN_ERROR = 'There was an unknown error publishing your audio/video';

    CrowdHub_App.LANG.NETWORK_STRENGTH_TEST_FAILED_TEXT =
      'Your network speeds are extremely slow and will cause connectivity issues. Please switch to a more stable network for a better experience.';
    CrowdHub_App.LANG.UNKNOWN_DEVICE_ERROR_TEXT =
      'Failed to get access to your camera or microphone. Please check that your webcam and/or microphone is connected and not being used by another application and try again.';

    CrowdHub_App.LANG.DELETE_ACCOUNT_BTN = 'DELETE ACCOUNT';
    CrowdHub_App.LANG.DELETE_ACCOUNT_TITLE = 'Permanently Delete Account?';
    CrowdHub_App.LANG.DELETE_ACCOUNT_CONFIRM = 'Delete Account';
    CrowdHub_App.LANG.DELETE_ACCOUNT_CANCEL = 'Cancel';
    CrowdHub_App.LANG.DELETE_ACCOUNT_MESSAGE = 'This cannot be undone.';
    CrowdHub_App.LANG.PLEASE_FILL_IN = 'Please fill in all required fields.';
    CrowdHub_App.LANG.PLEASE_FILL_IN_TITLE = "Some questions weren't answered.";
    CrowdHub_App.LANG.PLEASE_UPLOAD_AVATAR = 'Please upload an avatar.';

    CrowdHub_App.LANG.EXAM_ANSWERS_WRONG_TEXT = 'You have not answered all questions correctly.';
    CrowdHub_App.LANG.EXAM_ANSWERS_WRONG_TITLE = 'Please try again.';

    CrowdHub_App.LANG.SPEAKERS_TITLE = 'Speakers';

    CrowdHub_App.LANG.PRETEST_TITLE = 'Live Video Test';
    CrowdHub_App.LANG.PRETEST_SUBTITLE =
      "For the best experience let's make sure you can connect!<br><br>Please allow camera and microphone access when prompted!";
    CrowdHub_App.LANG.PRETEST_BUTTON = 'Begin Test';

    CrowdHub_App.LANG.TESTING_CONNECTIVITY = 'Testing Connectivity';
    CrowdHub_App.LANG.TESTING_CONNECTIVITY_CONFIRM_BUTTON = 'Okay';
    CrowdHub_App.LANG.TESTING_FAILED = 'Test Failed';
    CrowdHub_App.LANG.TURN_ON_VIDEO = 'Your video is off. Click to turn on.';
    CrowdHub_App.LANG.MUTE_YOURSELF = 'Mute your audio when not speaking';
    CrowdHub_App.LANG.UNMUTE_YOURSELF = 'You are muted, tap to unmute.';

    ///BEGIN CME
    // Langs
    /** titles */
    CrowdHub_App.LANG.CME_READY_TO_CLAIM_TITLE_TEXT = 'Ready to Claim';
    CrowdHub_App.LANG.CME_CONTENT_NEEDED_ALERT_POPUP_TITLE = 'You still have unfinished credit to earn!';
    CrowdHub_App.LANG.CME_IN_PROGRESS_TITLE_TEXT = 'In Progress';
    CrowdHub_App.LANG.CME_CLAIMED_TITLE_TEXT = 'Claimed';
    CrowdHub_App.LANG.CME_CONTENT_POPUP_TITLE_TEXT = 'Content needed for full credit.';
    CrowdHub_App.LANG.CME_QUESTION_PANEL_TITLE_TEXT = 'CME Questions';
    CrowdHub_App.LANG.CME_CLAIM_PANEL_TITLE_TEXT = 'Claim CME';
    CrowdHub_App.LANG.CME_CERTIFICATE_PANEL_TITLE_TEXT = 'Get Certificate';
    CrowdHub_App.LANG.CME_NOTIFICATION_TITLE = 'You have unclaimed CME';
    CrowdHub_App.LANG.CME_CERTIFICATE_TITLE = 'Certificate of Completion';
    CrowdHub_App.LANG.CME_CLAIMABLE_DATE_NOT_REACHED_TITLE_TEXT = '';
    CrowdHub_App.LANG.CME_NO_CONTENT_AVAILABLE_TITLE_TEXT = 'No content is avaiable for this CME yet';
    CrowdHub_App.LANG.CME_DEFAULT_ALERT_TITLE_TEXT = 'Please verify.';

    /** messages */
    CrowdHub_App.LANG.CME_CONTENT_NEEDED_ALERT_POPUP_MESSAGE = 'Click Continue to see what items you have left.';
    CrowdHub_App.LANG.CME_CONTENT_NEEDED_ALERT_CLAIM_POPUP_MESSAGE =
      'Click Claim Anyway to proceed with claiming credit for this CME.';
    CrowdHub_App.LANG.CME_CLAIM_PANEL_TEXT =
      'It looks like you have completed *|EARNED_HOURS|* of *|CREDIT_HOURS|* hours of this CME. Claim in full or adjust the amount to claim below.';
    CrowdHub_App.LANG.CME_NOTIFICATION_MESSAGE = '';
    CrowdHub_App.LANG.CME_CLAIMABLE_DATE_NOT_REACHED_MESSAGE_TEXT =
      'This CME is not available to claim until *|CLAIM_DATE|*';
    CrowdHub_App.LANG.CME_NO_CONTENT_AVAILABLE_MESSAGE_TEXT = 'No content is avaiable for this CME yet';
    CrowdHub_App.LANG.CME_CLAIMED_BANNER_TEXT = 'CME HOURS CLAIMED';
    CrowdHub_App.LANG.CME_TAP_FOR_CONTINUE_TEXT = 'Tap to continue';
    CrowdHub_App.LANG.CME_TAP_FOR_CERT_TEXT = 'Tap to view certificate';
    CrowdHub_App.LANG.CME_CLAIM_PANEL_ADJUSTMENT_LABEL_TEXT = 'Adjust the hours';
    CrowdHub_App.LANG.CME_ROW_NO_RESULTS_TEXT = 'No Results Found';
    CrowdHub_App.LANG.CME_DEFAULT_CLAIM_TEXT = 'CME Credit is available for completing *|CME_NAME|*.';
    CrowdHub_App.LANG.CME_COURSE_CLAIM_TEXT = 'CME Credit is available for completing this course.';
    CrowdHub_App.LANG.CME_NO_CREDIT_EARNED_TEXT =
      'You have not claimed or earned any hours for this CME. Please adjust the hours and try again.';
    CrowdHub_App.LANG.CME_CONTENT_POPUP_PROGRESS_TEXT = 'Progress needed:';

    /** buttons */
    CrowdHub_App.LANG.CME_CONTENT_LESSON_CLAIM_BUTTON_TEXT = 'Claim CME';
    CrowdHub_App.LANG.CME_CONTENT_TRACK_CLAIM_BUTTON_TEXT = 'Claim CME';
    CrowdHub_App.LANG.CME_READY_TO_CLAIM_BUTTON_TEXT = 'Claim';
    CrowdHub_App.LANG.CME_CONTENT_NEEDED_CONTINUE_BUTTON_TEXT = 'Continue Earning Credit';
    CrowdHub_App.LANG.CME_CONTENT_NEEDED_CLAIM_ANYWAY_BUTTON_TEXT = 'Claim Credit Anyway';
    CrowdHub_App.LANG.CME_QUESTION_PANEL_SAVE_BUTTON_TEXT = 'Save & Continue';
    CrowdHub_App.LANG.CME_CLAIM_PANEL_CLAIM_PARTIAL_BUTTON_TEXT = 'Claim Partial CME';
    CrowdHub_App.LANG.CME_CLAIM_PANEL_CLAIM_FULL_BUTTON_TEXT = 'Claim in Full';
    CrowdHub_App.LANG.CME_CERTIFICATE_PANEL_SAVE_BUTTON_TEXT = 'Download Certificate';

    /** search values */
    CrowdHub_App.LANG.CME_CERTIFICATE_TITLE_SEARCH_VALUE = '*|CERT_TITLE|*';
    CrowdHub_App.LANG.CME_CERTIFICATE_NAME_SEARCH_VALUE = '*|CERT_NAME|*';
    CrowdHub_App.LANG.CME_CERTIFICATE_FIRSTNAME_SEARCH_VALUE = '*|FIRST_NAME|*';
    CrowdHub_App.LANG.CME_CERTIFICATE_LASTNAME_SEARCH_VALUE = '*|LAST_NAME|*';
    CrowdHub_App.LANG.CME_CERTIFICATE_CMEHOURS_SEARCH_VALUE = '*|CME_HOURS|*';

    CrowdHub_App.LANG.CME_CONTENT_POPUP_DEFAULT_CONTENT_ICON_SRC = 'UserIcon_CrowdHub.jpg';

    CrowdHub_App.LANG.TOTAL_PLATFORM_VIEWS = 'Total Platform Views';
    CrowdHub_App.LANG.UNIQUE_PLATFORM_VIEWS = 'Unique Platform Views';

    CrowdHub_App.LANG.SOCIAL_TITLE_SEPARATOR = ' - ';
    CrowdHub_App.LANG.CHECK_TOKEN_LOGGING_OUT_TITLE = 'Logging Out';

    CrowdHub_App.LANG.TROUBLESHOOTING_HELP = "<a href='https://www.junolive.co/help'>Help me troubleshoot</a>";

    CrowdHub_App.LANG.GLOBAL_NOTIFICATION_POPUP_TITLE = 'Important';

    // Publish error codes and messages copied from:
    // https://static.opentok.com/developer/sdks/js/reference/Error.html
    // Update messages as necessary to make them better for the end user
    CrowdHub_App.LANG.PUBLISH_OT_CHROME_MICROPHONE_ACQUISITION_ERROR =
      'Chrome failed to get access to the microphone, due to a Chrome error. To work around this issue, you must restart Chrome and reload your site. This is a known issue to be fixed in Chrome.';
    CrowdHub_App.LANG.PUBLISH_OT_CONSTRAINTS_NOT_SATISFIED = 'We were unable to access a valid camera or microphone';
    CrowdHub_App.LANG.PUBLISH_OT_CREATE_PEER_CONNECTION_FAILED =
      'Failed to create a connection between this client and the subscriber or the Media Router.';
    CrowdHub_App.LANG.PUBLISH_OT_HARDWARE_UNAVAILABLE =
      'The hardware to fulfill the user media request appears to exist but could not be acquired. It might be in use by another application.';
    CrowdHub_App.LANG.PUBLISH_OT_ICE_WORKFLOW_FAILED = 'Something went wrong while establishing WebRTC connectivity.';
    CrowdHub_App.LANG.PUBLISH_OT_INVALID_PARAMETER = 'One or more parameters was not valid or not provided.';
    CrowdHub_App.LANG.PUBLISH_OT_MEDIA_ERR_ABORTED =
      'The fetching of the stream for the video element has been aborted.';
    CrowdHub_App.LANG.PUBLISH_OT_MEDIA_ERR_DECODE =
      'A decoding error occurred while trying to play the stream in the video element.';
    CrowdHub_App.LANG.PUBLISH_OT_MEDIA_ERR_NETWORK = 'A network error caused the stream to stop being fetched.';
    CrowdHub_App.LANG.PUBLISH_OT_MEDIA_ERR_SRC_NOT_SUPPORTED =
      'The stream has been detected to be not suitable for playback.';
    CrowdHub_App.LANG.PUBLISH_OT_NO_DEVICES_FOUND = 'No devices were found to provide the media stream.';
    CrowdHub_App.LANG.PUBLISH_OT_NO_VALID_CONSTRAINTS =
      'Video and audio were both disabled. You need to enable at least one.';
    CrowdHub_App.LANG.PUBLISH_OT_NOT_CONNECTED =
      "Couldn't perform action because you are not connected to the network.";
    CrowdHub_App.LANG.PUBLISH_OT_NOT_SUPPORTED = 'Something in the user media request is not supported.';
    CrowdHub_App.LANG.PUBLISH_OT_PERMISSION_DENIED =
      'This token does not allow publishing. The role must be at least publisher to enable this funcitonality.';
    CrowdHub_App.LANG.PUBLISH_OT_SCREEN_SHARING_NOT_SUPPORTED = 'Screen sharing is not supported in the browser.';
    CrowdHub_App.LANG.PUBLISH_OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED =
      'Screen-sharing support in this browser requires an extension, but one has not been registered.';
    CrowdHub_App.LANG.PUBLISH_OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED =
      'Screen-sharing support in this browser requires an extension, but the extension is not installed.';
    CrowdHub_App.LANG.PUBLISH_OT_SET_REMOTE_DESCRIPTION_FAILED = 'The WebRTC connection failed during setDescription.';
    CrowdHub_App.LANG.PUBLISH_OT_STREAM_CREATE_FAILED = 'Failed to create the stream in the server model.';
    CrowdHub_App.LANG.PUBLISH_OT_TIMEOUT = 'Could not publish in a reasonable amount of time.';
    CrowdHub_App.LANG.PUBLISH_OT_USER_MEDIA_ACCESS_DENIED =
      'User denied permission to access hardware devices. Please check that your browser has access to your camera and/or microphone. Note: - Chrome will also deny access without https.';
    CrowdHub_App.LANG.PUBLISH_OT_UNEXPECTED_SERVER_RESPONSE = 'There was an unexpected error from the server.';

    CrowdHub_App.LANG.ACCESS_DENIED_POPUP_TITLE = 'Access Denied';
    CrowdHub_App.LANG.ACCESS_DENIED_POPUP_MESSAGE = 'You do not have permission to access this page.';

    CrowdHub_App.LANG.AUDIO_BLOCKED_OVERLAY_HELP_TEXT = 'Click to enable audio';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_CONFIRM_TITLE = 'Select your share preference';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_CONFIRM_MESSAGE =
      "After a moderator approves, you will be brought into the session. When you're brought in, do you want to share video and audio or audio only?";
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_CONFIRM_SHARE_AV = 'Video + Audio';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_CONFIRM_SHARE_A = 'Audio';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_CONFIRM_CANCEL = 'Cancel Request';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_WAITING_TITLE = 'You are in the queue';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_WAITING_MESSAGE =
      'Moderators have been notified that you have raised your hand. When you are approved you will be brought into the session.';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_FINAL_CONFIRM_TITLE = 'You are being brought into the session';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_FINAL_CONFIRM_MESSAGE_AV =
      'Your microphone and camera will turn on automatically';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_FINAL_CONFIRM_MESSAGE_A = 'Your microphone will turn on automatically';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_FINAL_CONFIRM_CONTINUE = 'OK';
    CrowdHub_App.LANG.ATTENDEE_HAND_RAISE_TOOLTIP_WAITING_TEXT = 'Waiting...';
    CrowdHub_App.LANG.MODERATOR_HAND_RAISE_CONFIRM_TITLE = 'Allow User to Stream?';
    CrowdHub_App.LANG.MODERATOR_HAND_RAISE_CONFIRM_MESSAGE =
      '*|USER_FIRST_NAME|* *|USER_LAST_NAME|* is requesting to start streaming.';
    CrowdHub_App.LANG.MODERATOR_KICK_MEMBER_CONFIRM_TITLE = 'Are you sure you want to kick this member?';
    CrowdHub_App.LANG.MODERATOR_KICK_MEMBER_CONFIRM_MESSAGE = 'They will still be able to come back in to the session.';
    CrowdHub_App.LANG.MODERATOR_KICKBAN_MEMBER_CONFIRM_TITLE = 'Are you sure you want to ban this member?';
    CrowdHub_App.LANG.MODERATOR_KICKBAN_MEMBER_CONFIRM_MESSAGE = 'They will not be able to log back in!';

    CrowdHub_App.LANG.AWS_IVS_CLICK_TEXT = 'Attempting to connect to Live Stream';
    CrowdHub_App.LANG.AWS_IVS_AUDIO_BLOCKED_TEXT =
      'This video has been blocked from auto playing with audio. Please press play to continue watching with audio.';

    CrowdHub_App.LANG.TOKEN_EXPIRED_TITLE = 'Oops, it appears that link is expired.';
    CrowdHub_App.LANG.TOKEN_EXPIRED_MESSAGE = 'Please use the new link that was just sent to your email.';

    CrowdHub_App.LANG.GLOBAL_FEED_OPTION = 'Global Feed';

    CrowdHub_App.LANG.CORRECT_ANSWER = 'Correct Answer';

    /** file upload error messages */
    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_FILENOTFOUND =
      'File not found.<br><br>Something went wrong while attempting to load this file.<br><br>Please try again with a different file.';
    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILETYPE = `File Upload Error<br><br>We don't currently support *|TYPE|* files.<br><br>Please try again with a different file.`;
    CrowdHub_App.LANG.FORUM_FILE_UPLOAD_ERROR_INVALIDFILETYPE =
      '"We do not currently support uploading this file type on Forum or Social Feed posts.<br>Accepted media attachments include: <.png, .jpg, .gif, .tif>"';
    CrowdHub_App.LANG.FORUM_FILE_UPLOAD_ERROR_TITLE = 'Invalid File Type';
    // ASK BEFORE CHANGING
    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILESIZE = `File Upload Error<br><br>The max file size is ${GlobalHelperFunctions.generateHumanFileSize(
      CrowdHub_App.CONFIG.MAX_FILE_UPLOAD_SIZE_IN_BYTES,
    )}.<br><br>Please try again with a different file.`; // ASK BEFORE CHANGING

    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMESPACES =
      "File Upload Error<br><br>Spaces and special characters aren't compatible with our system.<br><br>Please rename your file and try again.";
    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMECHARACTERS =
      "File Upload Error<br><br>Spaces and special characters aren't compatible with our system.<br><br>Please rename your file and try again.";
    CrowdHub_App.LANG.FILE_UPLOAD_ERROR_INVALIDFILENAMELENGTH =
      'File Upload Error<br><br>Your file name is too long.<br><br>Please rename your file and try again.';

    /** file upload error messages */

    CrowdHub_App.LANG.FILE_UPLOAD_ONEATATIME_TITLE = 'Upload Error';
    CrowdHub_App.LANG.FILE_UPLOAD_ONEATATIME_MESSAGE = "We're sorry, we currently only support one upload at a time.";
    CrowdHub_App.LANG.FILE_UPLOAD_START_MESSAGE = 'Press Ok to continue.';
    CrowdHub_App.LANG.FILE_UPLOAD_PROGRESS_MESSAGE = 'File is uploading, please wait...';
    CrowdHub_App.LANG.FILE_UPLOAD_COMPLETE_MESSAGE = 'Complete! Press Ok to go back and finish saving.';

    CrowdHub_App.LANG.FILE_UPLOAD_FAILED_TITLE = 'File Upload Failed';

    CrowdHub_App.LANG.FILE_UPLOAD_FAILED_MESSAGE =
      'We apologize. Your upload failed due to a server error.<br>Error Message: '; // the error message will be appended to this string
    CrowdHub_App.LANG.FILE_UPLOAD_CANCEL_TITLE = 'Canceling File Upload!';
    CrowdHub_App.LANG.FILE_UPLOAD_CANCEL_MESSAGE = 'Are you sure you want to cancel this upload?';

    CrowdHub_App.LANG.FILE_UPLOAD_INITIAL_TEXT_TITLE = 'Feel free to continue editing or browsing the site.';
    CrowdHub_App.LANG.FILE_UPLOAD_INITIAL_TEXT_MESSAGE =
      '** Please keep this website open until your upload is complete.<br>Closing or navigating away from the site will cancel your upload.';

    CrowdHub_App.LANG.FILE_UPLOAD_CANT_NAVIGATE_TITLE = 'File Upload in Progress';
    CrowdHub_App.LANG.FILE_UPLOAD_CANT_NAVIGATE_MESSAGE = 'Please wait until your upload is complete.';

    CrowdHub_App.LANG.META_UPLOAD_BTN_TEXT = 'Upload File';
    CrowdHub_App.LANG.META_UPLOAD_INPUT_PLACEHOLDER = 'Video File (Max file size 10GB)';

    CrowdHub_App.LANG.FORUM_FET_CONFIRM_DELETE_BODY = 'Are you sure you want to delete this forum topic?';
    CrowdHub_App.LANG.FORUM_FET_CONFIRM_DELETE_TITLE = 'Delete Forum Topic?';
    CrowdHub_App.LANG.FORUM_FET_TOPIC_PLACEHOLDER = 'Topic Title';
    CrowdHub_App.LANG.FORUM_FET_DESCRIPTION_PLACEHOLDER = 'Topic Description';
    CrowdHub_App.LANG.FORUM_FET_TITLE_POST = 'Create Post';
    CrowdHub_App.LANG.FORUM_FET_TITLE_EDIT = 'Edit Forum Topic';
    CrowdHub_App.LANG.FORUM_FET_TITLE_NEW = 'New Forum Topic';
    CrowdHub_App.LANG.COMMUNITY_EDIT_TITLE = 'Save';

    CrowdHub_App.LANG.ANALYTICS_GENERATING_CSV =
      "<strong>Preparing Your Download</strong><br><br>You'll recieve an email with your report as soon as it's ready.";

    CrowdHub_App.LANG.ANALYTICS_GENERATING_CSV_ON_ERROR =
      '<strong>Export Unsuccessful</strong><br><br>It seems something went wrong while attempting to retrieve this file for you. Please try again in a few minutes.<br><br>If you continue to experience issues with your request, please reach out to ' +
      CrowdHub_App.LANG.HELPDESK_EMAIL +
      ' for help.';

    CrowdHub_App.LANG.FILE_UPLOAD_HEADER = 'Confirm File Upload Information To Begin Uploading Your File';
    CrowdHub_App.LANG.FILE_UPLOAD_INFO =
      'Once your upload is completed, your .mp4 will be converted to a .m3u8 file to provide the best quality for all viewers.';
    CrowdHub_App.LANG.FILE_UPLOAD_PLACEHOLDER = 'Choose a File…(10GB)';

    CrowdHub_App.LANG.PROFILE_DROPDOWN_SETTINGS = 'Settings';
    CrowdHub_App.LANG.BREAKOUTS_DISMISS_LOADING = 'OK';

    CrowdHub_App.LANG.PREFS_PANEL_SUBTITLE =
      'Note: We may still send you important information through notifications not included in these settings.';
    CrowdHub_App.LANG.PREFS_PANEL_SITE_TEXT = 'Which site would you like to adjust preferences for?';

    CrowdHub_App.LANG.MARK_ALL_NOTIFICATIONS_READ = 'Mark All As Read';
    CrowdHub_App.LANG.MARK_NOTIFICATIONS_READ = 'Mark As Read';
    CrowdHub_App.LANG.MARK_NOTIFICATIONS_UNREAD = 'Mark As Unread';
    CrowdHub_App.LANG.DELETE_NOTIFICATION = 'Delete Notification';
    CrowdHub_App.LANG.MANAGE_NOTIFICATIONS = 'Manage Notification';
    CrowdHub_App.LANG.NEW_FORUM_TOPIC_NOTIFICATION_HEADER = 'New Forum Topic!';
    CrowdHub_App.LANG.NEW_FORUM_TOPIC_NOTIFICATION_MESSAGE = 'Join the conversaton on'; // some content name
    CrowdHub_App.LANG.LMS_ENROLLMENT_UPDATE_NOTIFICATION_HEADER = 'Course Enrollment Update';
    CrowdHub_App.LANG.LMS_ENROLLED_NOTIFICATION_MESSAGE = 'You have been enrolled in the course,';
    CrowdHub_App.LANG.LMS_WAITLISTED_NOTIFICATION_MESSAGE = 'You have been added to the waitlist for';
    CrowdHub_App.LANG.ADMIN_NOTIFICATION_PREFS_NOTAVAILABLE =
      '<i>Notification preferences are not available at this time.<i>';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_INSTRUCTIONS =
      'Select the notifications you would like users on your site to receive';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_MESSAGES_HEADER = 'Message Alerts';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_SOCIAL_HEADER = 'Feed and Forum Notifications';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_WEB_PUSH = 'Browser Push Notifications';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_APP_PUSH = 'App Push Notifications';
    CrowdHub_App.LANG.ADMIN_NOTIFICATIONS_EMAIL_PUSH = 'Email Notifications';

    CrowdHub_App.LANG.GREENROOM_END_ALERT_TEXT = `Your audio/video will be stopped in: *|TIME|* <br>Click here to stop now.`;

    // Leaderboard
    CrowdHub_App.LANG.GROUP_LEADERBOARD_TITLE = 'Group Leaderboard';
    CrowdHub_App.LANG.GROUP_LEADERBOARD_BUTTON = 'Team Standings';
    CrowdHub_App.LANG.GROUP_LEADERBOARD_SEARCH = 'Search Teams';
    CrowdHub_App.LANG.USER_LEADERBOARD_BUTTON = 'Individual Standings';
    CrowdHub_App.LANG.USER_LEADERBOARD_SEARCH = 'Search Directory';
    CrowdHub_App.LANG.LEADERBOARD_DATA_ERROR = 'Error retrieving leaderboard data';

    // Badge Message
    CrowdHub_App.LANG.BADGE_COMPLETE_REPLACE = 'View Achievements';

    CrowdHub_App.CONFIG.USER_LISTS_NOT_TAG_ID = []; // hide users whose preferred tag id = this, in leaderboard and social post tagging

    CrowdHub_App.LANG.BLURB_EDIT_TITLE = 'Edit';
    CrowdHub_App.LANG.BLURB_IMAGE_UPLOAD_PROMPT = 'Upload Banner Image';

    CrowdHub_App.CONFIG.LOCATION_TINYMCE_STYLESHEET = '/crowdhub_admin_v2/admin/css/TinyMceCSS.css';
    CrowdHub_App.CONFIG.TINYMCE_MENUBAR = 'file edit view insert format tools table help';
    CrowdHub_App.CONFIG.TINYMCE_PLUGINS =
      'template preview media image importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap emoticons';

    CrowdHub_App.CONFIG.TINYMCE_EXTENDED_VALID_ELEMENTS =
      'iframe[allow|style|allowfullscreen|A|id|longdesc|name|src|frameborder|marginwidth|marginheight|scrolling|align|width|height|data],script[charset|defer|language|src|type|data],div[button_label|can_be_completed|class|charset|defer|language|src|type|data|width|height|padding|margin|style|id],a[class|style|href],i[class|style]';
    CrowdHub_App.CONFIG.TINYMCE_BUTTONS1 =
      '| bold italic underline strikethrough| alignleft aligncenter alignright alignjustify | formatselect | fontselect fontsizeselect | headings | forecolor backcolor |';
    CrowdHub_App.CONFIG.TINYMCE_BUTTONS2 =
      '| preview template | cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink image media code |';

    CrowdHub_App.CONFIG.TARGET_LIST = [
      { text: 'None', value: '' },
      { text: 'New window', value: '_blank' },
    ];

    CrowdHub_App.CONFIG.TINYMCE_TEMPLATES = [
      {
        title: 'Empty Iframe',
        description: 'Generates an empty <iframe>. ',
        content:
          '<div style="position: relative; height: 0; padding-bottom: 55%;"><div style="position: absolute; top: 0; left: 0; height: 100%; width: 100%;"><iframe style="border: 0px #FFFFFF none; width: 100%; height: 100%;" allowfullscreen="allowfullscreen" name="myiFrame" src="NO-SRC-SELECTED" frameborder="0" marginwidth="0" marginheight="0" scrolling="yes" width="300" height="150"></iframe></div></div>',
      },
      {
        title: 'Custom Footer',
        description:
          'Generates a custom footer which contains by default links to twitter, facebook and instagram. You will need to review and edit for branding/validity.',
        content:
          "<div class='bottom_bar_custom' style='display: flex; justify-content: center; width: 100%; padding: 10px 0; margin: 0; position: fixed; bottom: 0; left: 0; align-items: center; background-color: #c7169c; pointer-events: auto; z-index: 99;'><div style='text-align: center; padding: 5px 25px; width: 20%; display: flex; justify-content: space-between; align-items: center; color: #ffffff !important;'><a class='icon' style='color: white;' href='https://twitter.com/'><i class='fab fa-twitter'></i></a> <a class='icon' style='color: white;' href='http://www.facebook.com/'><i class='fab fa-facebook-f'></i></a> <a class='icon' style='color: white;' href='https://www.instagram.com//'><i class='fab fa-instagram'></i></a></div></div>",
      },
      {
        title: 'Help Text',
        description: 'Generates a <span> with some default help text. ',
        content:
          '<span style="font-size: 14pt;">For any questions not answered below in our FAQ, or for technical support, please use the "Help Chat" under your profile picture on the top right of the page. Many questions can be answered using our automated system, but if you need to speak to a team member, please follow the instructions in the chat. Queries and technical questions on the Discussion Board will not be checked by our team.</span>',
      },
      {
        title: 'Help Page',
        description: 'Generates a fully populated help page. You will need to review and edit for branding/validity.',
        content:
          "<h1><span style='font-weight: 300;'>Welcome to CLIENT_NAME!</span></h1><h1><span style='font-weight: 300;'>Platform Specific Questions&nbsp;</span></h1><h2><strong>How should I set up my device for the best experience?&nbsp;</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>Follow these tips to set up for success!&nbsp;</span></p><ul><li style='font-weight: 300;'><span style='font-size: 12pt;'><span style='font-weight: 300;'>Make sure your browseris up to date with the latest version. We recommend using Google Chrome. </span><a href='https://www.google.com/chrome/?brand=YTUH&amp;gclid=CjwKCAiA_eb-BRB2EiwAGBnXXq0goNJCPY26W9TfybvzNm8aBHPCe6XFWxfj-pgspVXepSiKbyhocBoC9IUQAvD_BwE&amp;gclsrc=aw.ds'><span style='font-weight: 300;'>Download Chrome here.</span></a><span style='font-weight: 300;'> Firefox,Safari, Microsoft Edge, and Opera are also supported. Internet Explorer is not supported.</span></span></li><li style='font-weight: 300;'><span style='font-weight: 300; font-size: 12pt;'>Make sure your operating system is up to date. We support Windows 7 or later and Mac OS 10.12 or later.&nbsp;</span></li><li style='font-weight: 300;'><span style='font-weight: 300; font-size: 12pt;'>Make sure your camera and microphonehave permission to be used. Check your browser and device settings.</span></li><li style='font-weight: 300;'><span style='font-weight: 300; font-size: 12pt;'>Disable browser extensions or pluginsthat are large or privacy-related.</span></li><li style='font-weight: 300;'><span style='font-weight: 300; font-size: 12pt;'>Disconnect from any VPN.</span></li></ul><p><span style='font-size: 12pt;'><a href='https: //help.junolive.com/support/Top-troubleshooting-tips.880410625.html'><span style='font-weight: 300;'>Click here to get specific instructions for your browser ordevice.</span></a></span></p><h2><strong>Do I have to convert times to my time zone?</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>No, all times on the site are automatically shown inyour time zone (as it is set on your computer).&nbsp; Check your computer&rsquo;s clock! Our site sets yourtime zone based on your computer, so it will be incorrect if your physical time zone is different than yourcomputer&rsquo;s. Learn how to change your time zone for </span><a href='https: //support.apple.com/guide/mac-help/set-the-date-and-time-mchlp2996/mac'><span style='font-weight: 300;'>Mac</span></a><span style='font-weight: 300;'> and </span><a href='https://support.microsoft.com/en-us/windows/how-to-set-your-time-and-time-zone-dfaa7122-479f-5b98-2a7b-fa0b6e01b261'><span style='font-weight: 300;'>Windows</span></a><span style='font-weight: 300;'>.</span></span></p><h2><strong>Once I am in, how do I set up my profile?&nbsp;</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>In the top right corner, click on your profile phototo open your profile. From here you can edit your profile and preferences at any time. Make sure to selectyour areas of interest, add your specialty and add your availability if you&rsquo;d like to be available forvideo chats!. </span><a href='https: //help.junolive.com/attendees/Set-your-availability-for-meetings.766509063.html'><span style='font-weight: 300;'>Learn how to set your availability for one-on-one meetings.</span></a></span></p><h2><strong>How do I set up my schedule?&nbsp;</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>Click the Attend button next to any session orworkshop to add it to your personal schedule. You can only &ldquo;attend&rdquo; </span><span style='font-weight: 300;'>workshops</span><span style='font-weight: 300;'> you are registered for, and havepaid for.</span></span></p><h2><strong>How do I go to a session that&rsquo;s in my schedule?</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>Go to the Program tab and then click Schedule in the Sub NavigationBar to see a list of ALL the sessions. Then click My Schedule to see a list of the sessions you selected toattend. The clock next to each session counts down until it goes LIVE. When it&rsquo;s time, click on a sessionto enter it. If you don&rsquo;t want to set up a personal schedule, you can just click into sessions from theMain Stage, Workshops or Optional Activities tabs.</span></p><h2><strong>I can't hear the session. What do I do?&nbsp;</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>Hover over the video playing on the screen and makesure to turn up the volume, just like you would for a YouTube video. Also, check if the volume on yourdevice is turned up. </span><a href='https: //help.junolive.com/support/Attendee-session-tips.893583367.html'><span style='font-weight: 300;'>See more troubleshooting tips.</span></a></span></p><h2><strong>Why does a video stall or not play smoothly?&nbsp;</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>The video quality will automatically adjust based onyour internet speed. If you&rsquo;re on wifi, try moving closer to your router. Or connect directly to yourrouter via an ethernet cable. </span><a href='https: //help.junolive.com/support/Attendee-session-tips.893583367.html'><span style='font-weight: 300;'>See more troubleshooting tips.</span></a></span></p><h2><strong>Can I rewind or start over?&nbsp;</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>In some pre-recorded sessions you can! If you see controls at thebottom of the video, you can use them to rewind or start over, just like you would for a YouTube video. If thereare no controls, you cannot rewind or start over.</span></p><h2><strong>What should I do if I need more help with the platform?</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>We&rsquo;re ready to help!</span></p><p><span style='font-weight: 300; font-size: 12pt;'>Anyone can click the &ldquo;Help Chat&rdquo; (question mark icon) inthe top right corner under your profile picture to start a help chat. If you are unable to get your questionsanswered using the automated system, you can also speak to a live CLIENT_NAME Team Member, who will bestanding by during conference hours. We will also have a technical support room available to be able to walk youthrough any technical issues. You can get this link by talking to the live support person in the HelpChat.&nbsp;</span></p><p><span style='font-weight: 300; font-size: 12pt;'>Please don&rsquo;t post questions in the session chat, discussionboard or by personal message to the organizers. We need to keep all support requests in one place to make surenone of your questions get missed.&nbsp;</span></p><h2><strong>When will live session recordings be available to watch?&nbsp;</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>We are aiming to get the recordings edited and posted within theconference weekend. Some may take a few days. Find them in the Recordings tab under Program in the navigationbar.&nbsp;</span></p><h2><strong>How can I see who else is attending the conference?&nbsp;</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>Go to the Social tab and click Attendees to see a list of allattendees. Want to learn more about someone? Click on their name or photo to view their profile. You canalsoFilter attendees by interest tags or specialty.&nbsp;</span></p><h2><strong>How do I connect with people individually?&nbsp;</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>Make sure to </span><a href='https: //help.junolive.com/attendees/Set-your-availability-for-meetings.766509063.html'><span style='font-weight: 300;'>select Allow members to contact me </span></a><span style='font-weight: 300;'>in your personal profile. This lets other attendees contact you.</span></span></p><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>Wherever you see someone&rsquo;s profile photo, clickit to open their profile. From there, you can </span><a href='https: //help.junolive.com/attendees/Send-direct-messages.766640143.html'><span style='font-weight: 300;'>send direct messages</span></a><span style='font-weight: 300;'> or </span><a href='https: //help.junolive.com/attendees/Schedule-meetings-with-other-attendees.766345461.html'><span style='font-weight: 300;'>schedule one-on-one video meetings</span></a><span style='font-weight: 300;'>that happen right here on the site!</span></span></p><h2><strong>Do I need to coordinate times for one-on-one meetings?</strong></h2><p><span style='font-size: 12pt;'><span style='font-weight: 300;'>All you have to do is </span><a href='https: //help.junolive.com/attendees/Set-your-availability-for-meetings.766509063.html'><span style='font-weight: 300;'>set your availability and away dates</span></a> <span style='font-weight: 300;'> in your profile. Then people will only be able to select time slots thatyou&rsquo;re available. We also automatically block your calendar when you add sessions or other meetings toyour schedule.</span></span></p> <h2><strong>How do I find notifications and direct messages?</strong></h2><p><span style='font-weight: 300; font-size: 12pt;'>Near your profile photo in the top right corner, click the Speechbubble icon for direct messages or the Bell icon for notifications.</span></p><br><br><h1><span style='font-weight: 300;'>GENERAL FAQ&nbsp;</span></h1><br><br>",
      },
    ];
    CrowdHub_App.LANG.BUTTON_CE_CLAIM = 'Claim Credits';
    CrowdHub_App.LANG.BUTTON_CE_COMPLETE = 'Complete';
    CrowdHub_App.LANG.BUTTON_CE_CLAIM_TOOLTIP_MOBILE_TITLE = 'CE Status';

    //tool tip message on Content CE button is based on content type
    CrowdHub_App.LANG.BUTTON_CE_TOOLTIP_CLAIM_LATER = 'Credits may be claimed once the session has started.';
    CrowdHub_App.LANG.BUTTON_CE_TOOLTIP_COMPLETE = "You've already claimed these credits.";
    CrowdHub_App.LANG.BUTTON_CE_TOOLTIP_CLAIM = 'Click to claim credits.';
  }
}
